import React from 'react';
import Sidebar from '../Components/Sidebar';
import TopBar from '../Components/TopBar';
import { useState, useEffect, useRef, useContext, createRef } from 'react';
import CopyPaste from '../Components/CopyPaste';
import { useDispatch } from 'react-redux';
import { addScreenshotsTop, addScreenshotsBottom, setFormScreenshot, setCalledFrom } from '../store/slices/DocumentClaimSlice';
import { addUploadedFiles } from '../store/slices/DocumentClaimSlice';
import { useSelector } from 'react-redux';
import { useScreenshot } from 'use-react-screenshot';
import axios from 'axios';
import Select from 'react-select';
import useLoader from "../Hook/useLoader"
import { getMSID, getToken } from '../common';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import ViewHistoryPopup from "../Components/ViewHistoryPopup";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useParams } from 'react-router-dom';
import { UserContext } from "../Hook/UserContext";
import AppInsight from "../AppInsight";
import { styled } from '@mui/system';
import Swal from 'sweetalert2';
import SnackBar from '../Components/SnackBar';
import domtoimage from 'dom-to-image';
import * as htmlToImage from 'html-to-image';
import JSZip from "jszip";
import {saveAs} from "file-saver";



const CustomMessage = styled('div')({
})




const DocumentClaimScreen = () => {
    const params = useParams();
    const [versionCount, setVersionCount] = useState(1);
    const [loader, showLoader, hideLoader] = useLoader({ heightOfLoader: '160vh', marginTopLoader: '34%' });
    const [inProgressLoader, showInProgressLoader, hideInProgressLoader] = useLoader();
    const [msid, setMsid] = useState();
    const {userRole,code1,setCode} = useContext(UserContext);
    const [approvalPending, setApprovalPending] = useState(false);
    const [commentScrnshot, setCommentScrnshot] = useState([[]]);
    const [showClaimDetails, setShowClaimDetails] = useState(true);
    const [claimCreator,setClaimCreator] = useState("NA");
    const [fileName, setFileName] = useState("");
    const [isCompleted,setIsCompleted]=useState("");
    const buttonClicked=useRef(false);
    const [commentInput, setCommentInput] = useState({
        comment: "",
    })
    const handleChangeComment = (e) => {
        const { name, value } = e.target;
        setCommentInput({ ...commentInput, [name]: value, });
    }

    const Swal = require('sweetalert2')
    const inputDcsRef = useRef({
        auditedClaim: "",
        auditedClaimSeq: "",
        adjustedClaim: "",
        adjustedClaimSeq: "",
        rxclaim_Instance: params.pkey.slice(params.pkey.search(/[^\d]/)),
        completionDate: "",
        creationDate: "",
        ClientFeeAndShareIndi: "",
        pharmacyAdjAmtInputField1: "",
        pharmacyAdjAmtInputField2: "",
        pharmacyAdjAmtInputFieldResult: "",
        ClientAdjAmtInputField1: "",
        ClientAdjAmtInputField2: "",
        rts_report: "",
        violation: "",
        ClientAdjAmtResult: "",
        contactName: "",
        calls: "",
        emails: "",
        claimReference: "",
        Sig: "",
        rOrr: "",
        notes: "",
    });
    const commentRef = useRef({
        commentData: "",
    });
    const refAdjustedClaim = useRef("");
    let role = "";
    if (userRole === 1||userRole===3) {
        role = "manager";
    } else if (userRole === 2||userRole===4) {
        role = "auditor";
    }
    let accessRole="";
    if (userRole === 1) {
        accessRole = "admin";
    } else if (userRole === 2) {
        accessRole = "auditor";
    }
    else if (userRole === 3) {
        accessRole = "off-admin";
    }
    else{
        accessRole="off-auditor";
    }
    const [isDragging , setIsDragging]=useState(false);
    const [isCallNotesChanged, setIsCallNotesChanged] = useState(false);
    const [areImagesChanged, setAreImagesChanged] = useState(false);
    const [areUploadFilesDeleted, setAreUploadFilesDeleted] = useState(false);
    let imagesChanged = false;
    let callNotesChanged = false;
    let rxWebCallNotesChanged = false;

    
    const[imageDomState,setImageDomState]=useState(null);
    const captureScreenshot=()=>{
    }

    const [deletedUploadFileName, setDeletedUploadFileName] = useState('');
    const [responseFromGetApi, setResponseFromGetApi] = useState({});
    useEffect(() => {
        try {
            
            let loggedUserMsid = getMSID();
            setMsid(loggedUserMsid);
            const index = params.pkey.search(/[^\d]/);
            if (index !== -1) {
            }
            else {
            }
            if (params.pkey !== undefined){
                handleGetApiCall();
                callGetApiDocumentData(0, "initialload", params.pkey, loggedUserMsid);
            }
        }
        catch (error) {
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error => getting msid, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }, [])
    const [showSubmitButtons, setShowSubmitButtons] = useState(false);
    const [showAccordion, setShowAccordion] = useState(false);
    const [showHistoryPopup, setShowHistoryPopup] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const alertRef = useRef();
    const [commentError, setCommentError] = useState(false);
    //to validate the required field to be filled
    const validate = (values) => {
        const errors = {};
        if (inputDcsRef.current.adjustedClaim !== null && inputDcsRef.current.adjustedClaim.value === "") {
            errors.adjustedClaim = "Adjusted claim is required!";
        }
        else if (inputDcsRef.current.adjustedClaim !== null && inputDcsRef.current.adjustedClaim.value.length < 15) {
            errors.adjustedClaim = "Adjusted Claim must be 15 digits";
        }
        if (inputDcsRef.current.adjustedClaimSeq !== null && inputDcsRef.current.adjustedClaimSeq.value === "") {
            errors.adjustedClaimSeq = "Adjusted Claim Sequence is required!";
        }
        if (inputDcsRef.current.ClientFeeAndShareIndi !== null && inputDcsRef.current.ClientFeeAndShareIndi.value.trim() === "") {
            errors.ClientFeeAndShareIndi = "Client Fee & Share Indicator is Required!";
        }
        if (inputDcsRef.current.pharmacyAdjAmtInputField1 !== null && inputDcsRef.current.pharmacyAdjAmtInputField1.value === "") {
            errors.pharmacyAdjAmtInputField1 = "Pharmacy Adjustment Amount on field one is required!";
        }
        if (inputDcsRef.current.pharmacyAdjAmtInputField2 !== null && inputDcsRef.current.pharmacyAdjAmtInputField2.value === "") {
            errors.pharmacyAdjAmtInputField2 = "Pharmacy Adjustment Amount on field two is required!";
        }
        if (inputDcsRef.current.contactName !== null && inputDcsRef.current.contactName.value.trim() === "") {
            errors.contactName = "Contact name is required!";
        }
        if (inputDcsRef.current.calls !== null && (inputDcsRef.current.calls.value === "" || inputDcsRef.current.calls.value === 0)) {
            errors.calls = "Calls is required!";
        }
        if (inputDcsRef.current.emails !== null && inputDcsRef.current.emails.value === "") {
            errors.emails = "Emails is required!";
        }
        if (inputDcsRef.current.rts_report !== null && inputDcsRef.current.rts_report.value === "Select RT or Report") {
            errors.rts_report = "RTS or REPORT is required!";
        }
        if (inputDcsRef.current.violation !== null && inputDcsRef.current.violation.value === "Select Violation") {
            errors.violation = "Violation is required!";
        }
        if (inputDcsRef.current.claimReference !== null && inputDcsRef.current.claimReference.value !== "" && inputDcsRef.current.claimReference.value.length < 15) {
            errors.claimReference = "Claim reference must be 15 digits";
        }
        if (inputDcsRef.current.Sig !== null && inputDcsRef.current.Sig.value === "") {
            errors.Sig = "Sig is required!";
        }
        if (inputDcsRef.current.rOrr !== null && inputDcsRef.current.rOrr.value === "") {
            errors.rOrr = "R/R is required!";
        }
        if (inputDcsRef.current.notes !== null && inputDcsRef.current.notes.value === "") {
            errors.notes = "Notes is required!";
        }
        if (inputDcsRef.current.rOrr !== null && inputDcsRef.current.Sig !== null && inputDcsRef.current.Sig.value.trim().length + inputDcsRef.current.rOrr.value.trim().length > 150) {
            errors.rOrrSig = "Total length of R/R and Sig should not exceed 150 characters."
        }
        return errors;
    };

    const validateSaveAndContinue = (values) => {
        const errors = {};
        if (inputDcsRef.current.adjustedClaim !== null && inputDcsRef.current.adjustedClaim.value !== "" && inputDcsRef.current.adjustedClaim.value.length < 15) {
            errors.adjustedClaim = "Adjusted Claim must be 15 digits";
        }
        if (inputDcsRef.current.claimReference !== null && inputDcsRef.current.claimReference.value !== "" && inputDcsRef.current.claimReference.value.length < 15) {
            errors.claimReference = "Claim reference must be 15 digits";
        }
        return errors;
    };

    const validateImage = (url) => {
        return new Promise((resolve) => {  
          const image = new Image();
      
          image.onload = () => {
            resolve(true); // Image loaded successfully
          };
      
          image.onerror = () => {
            // console.log('Image is corrupted.');
            resolve(false); // Image failed to load
          };
      
          image.src = url;
        });
      };
      

    const corruptImgCheck = async() => {
        let topFlag = false;
        let bottomFlag=false;
        let commentFlag=false;
        let sec = '';
        for (const img of val) {

          if (!topFlag&&img.length>0) {
            console.log("img", img);
            const isValid=await validateImage(img[0]);
            console.log("isValid",isValid)
                if (!isValid) {
                    topFlag = true;
                }
            }
        }
        
        for (const img of valBottom) {
            if (!bottomFlag&&img.length>0) {
                const isValid=await validateImage(img[0]);
                if (!isValid) {
                    bottomFlag = true;
                }   
            }
        }
        
       
        for (const img of commentScrnshot) {
                if (!commentFlag&&img.length>0) {
                    const isValid=await validateImage(img[0]);
                    if (!isValid) {
                        commentFlag = true;
                    }   
                }
        }

        if(topFlag){
            sec = 'top, ';
        }
        if(bottomFlag){
            sec+='bottom, ';
        }
        if(commentFlag){
            sec+='comment, ';
        }
        if(sec!==''){
         sec=sec.slice(0,-2);
        }
         
        
        console.log("Final result:", { isCorrupted: topFlag||bottomFlag||commentFlag, section: sec });

        return {isCorrupted : topFlag||bottomFlag||commentFlag, section:sec};
      };

    const [data, setData] = useState([]);
    const currentUser = role;
    const handleGetApiComment = () => {
        try {
            CallGetCommentApi();
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => handleGetApiComment in ViewHistoryPopup, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    };

    const CallGetCommentApi = async () => {
        const token = getToken();
        const header = {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        };
        try {
            AppInsight.trackEvent({ name: `PNA Frontend=>CallGetCommentApi API Call started, msid=> ${msid}`});
            const response = await axios.get(
                process.env.REACT_APP_API_URI + "CommentsData?key=" + params.pkey, header);
                AppInsight.trackEvent({ name: `PNA Frontend=>CallGetCommentApi API Call completed, msid=> ${msid}`});

            if (response.status === 200) {
                //  alertRef.current.showSnackbar();
                const processedData = response.data.commentsData.map(item => ({
                    ...item,
                    date: formatDateComment(new Date(item.creation_date)),
                    time: formatTimeComment(new Date(item.creation_date)),
                    image: (item.screenshot === null || item.screenshot === "") ? (item.screenshot) : ("data:image/png;base64," + item.screenshot),

                }))
                const latestData = getLatestData(processedData, currentUser);
                const latestComments= processedData.filter((item,index)=>index<2)
                if (latestData !== null && latestData !== "") {
                    if (latestData.status === "sent back") {
                        latestData.status = "Sent Back";
                    }
                    else if (latestData.status === "approved") {
                        latestData.status = "Approved";
                    }
                    else if (latestData.status === "denied") {
                        latestData.status = "Denied";
                    }
                }
                setData(latestComments);
            }
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => callDownloadDocumentsAPI, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }

    const getLatestData = (data, role) => {
        if (!data || data.length === 0) return null;
        const latest = data.reduce((latest, current) => {
            const latestDate = new Date(`${latest.date}`);
            const currentDate = new Date(`${current.date}`);
            return currentDate > latestDate ? current : latest;
        })
        return latest;
    }
    const formatDateComment = (date) => {
        const optionDate = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        return date.toLocaleDateString('en-US', optionDate).replace(/[/]/g, '-');
    }
    const formatTimeComment = (date) => {
        const time = new Date(date.getTime());
        const optionTime={
            minute:'numeric',
            second:'numeric',
            hour:'numeric',
            //timeZone:'America/Chicago'
        }
        const month= String((time.getMonth())+1).padStart(2,'0');
 
         const dayOfMonth= String((time.getDate())).padStart(2,'0');
        const year = String(time.getFullYear());
        const hour = String(time.getHours()).padStart(2, '0');
        const min = String(time.getMinutes()).padStart(2, '0');
        const seconds = String(time.getSeconds()).padStart(2,'0');
 
        return `${month}-${dayOfMonth}-${year}  ${hour}:${min}:${seconds} CST`;
    }
    useEffect(() => {
        handleGetApiComment();
    }, [])

    const [snackBarForamttedMsg, setSnackBarForamttedMsg] = useState('');
    const formatDate = (dateW) => {
        const date = new Date(dateW);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = String(date.getFullYear());
        const hour = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${month}/${day}/${year}`;
    }

    const formatDateAndTime = (dateW) => {
        const date = new Date(new Date(dateW).getTime());
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = String(date.getFullYear());
        const hour = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${month}/${day}/${year} ${hour}:${min}`;
    }

    const versionStyles = {
        control: (provided, state) => (
            {
                ...provided,
                height: '10px',
                //borderRadius: '15px',
                color: 'black',
                textDecoration: 'none',
            }
        ),
        placeholder: (provided) => ({
            ...provided,
            height: '10px',
            color: 'black',
            textAlign: 'center',
            fontStyle: 'italic',
            textDecoration: 'none',

        }),
        input: (provided) => ({
            ...provided,
            color: 'black',
            //height: '10px',
            textAlign: 'center',
            fontStyle: 'italic',
            fontSize: '10px',
            textDecoration: 'none',

        }),
        singleValue: (provided) => ({
            ...provided,
            //height: '20px',
            color: 'black',
            textDecoration: 'none',

        }),

        menu: (provided) => (
            {
                ...provided,
                textAlign: 'left',
                textDecoration: 'none',
            }
        )
    };

    const [isFinalDecisionChecked, setIsFinalDecisionChecked] = useState(false);
    const [isUpdateClaimChecked, setIsUpdateClaimChecked] = useState(false);
    const pKey = useSelector((state) => {  //get data from the main store
        return state.documentClaim.pkey;
    })
    const formRef = useRef();
    const [image, takeScreenshot] = useScreenshot();
    const getImage = () => {
        captureScreenshot();
    }
    const handleFinalDecisionCheckBoxChange = () => {
        const validations = validate(inputsDcs);
        setFormErrors(validations);
        if (Object.keys(validations).length === 0) {
            setIsFinalDecisionChecked(!isFinalDecisionChecked);
        }
        if (Object.keys(validations).length > 0) {
            if(alertRef.current)
                alertRef.current.showSnackbar(snackBarForamttedMsg, "error");
        }
    }

    const handleIsUpdateClaimChecked = (clicked) => {
        const validations = validate(inputsDcs);
        checkCallNotesChangeFlag();
        setFormErrors(validations);
        const formattedMsg = Object.entries(validations).map(([key, value]) =>
            `${value}`).join('\n');
        if (Object.keys(validations).length === 0) {
            if (clicked === "clicked")
                {
                    if(rxWebCallNotesChanged===false&&claimStatus!=='Fallout')
                    {
                        if(alertRef.current)
                            alertRef.current.showSnackbar("You need to change callnotes to be able to submit to RxWeb/RxClaim", "error");
                    }
                    else
                    setIsUpdateClaimChecked(!isUpdateClaimChecked);
                }
        }
        if (Object.keys(validations).length > 0) {
            if(alertRef.current)
                alertRef.current.showSnackbar(formattedMsg, "error");
            setIsUpdateClaimChecked(isUpdateClaimChecked);
        }
    }

    const handleSaveAndContinueValidations = () => {
        const validations = validateSaveAndContinue(inputsDcs);
        setFormErrors(validations);
        const formattedMsg = Object.entries(validations).map(([key, value]) =>
            `${value}`).join('\n');
        if (Object.keys(validations).length > 0) {
            if(alertRef.current)
                alertRef.current.showSnackbar(formattedMsg, "error");
            buttonClicked.current=false;
            return true;
        }
        return false;
    }
    useEffect(() => {
        dispatch(setFormScreenshot(image));
    }, [image]);
    const [claimStatus, setClaimStatus] = useState("");
    const [versionId, setVersionId] = useState("");
    const [creator, setCreator] = useState("");
    const [inputsDcs, setInputsDcs] = useState({
        auditedClaim: params.pkey.slice(0, params.pkey.search(/[^\d]/)),
        auditedClaimSeq: "",
        adjustedClaim: "",
        adjustedClaimSeq: "",
        rxclaim_Instance: params.pkey.slice(params.pkey.search(/[^\d]/)),
        completionDate: "",
        creationDate: formatDateAndTime(new Date()),
        ClientFeeAndShareIndi: "",
        pharmacyAdjAmtInputField1: "",
        pharmacyAdjAmtInputField2: "",
        pharmacyAdjAmtInputFieldResult: 0,
        ClientAdjAmtInputField1: "",
        ClientAdjAmtInputField2: "",
        rts_report: "",
        violation: "",
        ClientAdjAmtResult: 0,
        contactName: "",
        calls: "",
        emails: "",
        claimReference: "",
        Sig: "",
        rOrr: "",
        notes: "",
    });
    const [inputsDcsOfGetApi, setinputsDcsOfGetApi] = useState({
        auditedClaim: params.pkey.slice(0, params.pkey.search(/[^\d]/)),
        auditedClaimSeq: "",
        adjustedClaim: "",
        adjustedClaimSeq: "",
        rxclaim_Instance: params.pkey.slice(params.pkey.search(/[^\d]/)),
        completionDate: "",
        creationDate: formatDateAndTime(new Date()),
        ClientFeeAndShareIndi: "",
        pharmacyAdjAmtInputField1: "",
        pharmacyAdjAmtInputField2: "",
        pharmacyAdjAmtInputFieldResult: 0,
        ClientAdjAmtInputField1: "",
        ClientAdjAmtInputField2: "",
        rts_report: "",
        violation: "",
        ClientAdjAmtResult: 0,
        contactName: "",
        calls: "",
        emails: "",
        claimReference: "",
        Sig: "",
        rOrr: "",
        notes: "",

    });
    

    const checkCallNotesChangeFlag = () => {
        const keysInputDcs = Object.keys(inputDcsRef.current);
        const keysinputsDcsOfGetApi = Object.keys(inputsDcsOfGetApi);
        let changed = false;
        if (keysInputDcs.length !== keysinputsDcsOfGetApi.length) {
            setIsCallNotesChanged(true);
            callNotesChanged = true;
        }
        else {
            for (const key of keysInputDcs) {
                if (inputDcsRef.current[key] !== "" && String(inputDcsRef.current[key].value).trim() !== String(inputsDcsOfGetApi[key]).trim()) {
                    changed = true;
                    setIsCallNotesChanged(true);
                    callNotesChanged = true;
                    if (key !== "ClientFeeAndShareIndi" && key !== "claimReference" && key !== "notes") {
                        rxWebCallNotesChanged = true;
                    }
                }
            }
            if (changed === false) {
                setIsCallNotesChanged(false);
                callNotesChanged = false;
                rxWebCallNotesChanged = false;
            }
        }
    }

    const checkCallNotesChangeFlagSidebar = () => {
        let isSidebarCallNotesChanged=false;
        const keysInputDcs = Object.keys(inputDcsRef.current);
        const keysinputsDcsOfGetApi = Object.keys(inputsDcsOfGetApi);
        let changed = false;
        if (keysInputDcs.length !== keysinputsDcsOfGetApi.length) {
            isSidebarCallNotesChanged=true;
        }
        else {
            for (const key of keysInputDcs) {
                if (inputDcsRef.current[key] !== ""&&inputDcsRef.current[key] !== null && String(inputDcsRef.current[key].value).trim() !== String(inputsDcsOfGetApi[key]).trim()) {
                    changed = true;
                    isSidebarCallNotesChanged=true
                }
            }
        }
        return isSidebarCallNotesChanged;
    }


    const [versionOptions, setVersionOptions] = useState([
    ]);
    const [maxVersion, setMaxVersion] = useState(
        { value: '1', label: '1' }
    );
    const [versionSelected, setVersionSelected] = useState(
        { value: '1', label: 'None' }
    );
    const versionDropdownChange = (event) => {
        setVersionSelected(event);
        callGetApiDocumentData(Number(event.value), "versionChange", params.pkey, msid);
    }
    const [getApiResponse, setGetApiResponse] = useState("");
    const handleDowloadFile = async (file, valueCheck) => {
        try {
            if (valueCheck === false)
                return;
            callDownloadFileAPI(file);
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error => handleDowloadFile, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }
    const callDownloadFileAPI = async (file) => {
        const token = getToken();
        const header = {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            responseType: 'blob',
        };
        if (claimStatus !== "In-Progress")
            showLoader();
        else
            showInProgressLoader();
        try {
            AppInsight.trackEvent({ name: `PNA Frontend=>callDownloadFileAPI API Call started, msid=> ${msid}`});
            const response = await axios.get(
                process.env.REACT_APP_API_URI + "ClaimsDocumentPageDownloadFiles?key=" + params.pkey + "&filename=" + file, header
            );
            AppInsight.trackEvent({ name: `PNA Frontend=>callDownloadFileAPI API Call completed, msid=> ${msid}`});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file)
            document.body.appendChild(link);
            link.click();
            if (claimStatus !== "In-Progress")
                hideLoader();
            else
                hideInProgressLoader();
            document.body.removeChild(link);
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            hideInProgressLoader();
            hideLoader();
            AppInsight.trackEvent({ name: `PNA Frontend => callDownloadFileApi Error, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }

    const callGetApiDocumentData = async (version, calledFrom, pkey, msid) => {
        try {
            callClaimsDocumentPageDatabindAPI(version, calledFrom, pkey, msid);
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error => callGetApiDocumentData, msid=> ${msid}`, properties: { errorMessage: error.message } });

        }
    }
    const callClaimsDocumentPageDatabindAPI = async (version, calledFrom, pkey, msid) => {
        const token = getToken();
        const header = {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        };
        if (claimStatus !== "In-Progress")
            showLoader();

        else
            showInProgressLoader();
        //call
        try {
            AppInsight.trackEvent({ name: `PNA Frontend=>callClaimsDocumentPageDatabindAPI API Call started, msid=> ${msid}`});
            const response = await axios.get(process.env.REACT_APP_API_URI + "ClaimsDocumentPageDatabind?" + "version=" + `${version}` + "&key=" + `${pkey}`+"&role="+`${accessRole}`, header);
            // const response = await axios.get(process.env.REACT_APP_API_URI + "ClaimsDocumentPageDatabind?" + "version=" + `${version}` + "&key=100A2_AZM");
            AppInsight.trackEvent({ name: `PNA Frontend=>callClaimsDocumentPageDatabindAPI API Call completed, msid=> ${msid}`});
            if (response.status === 200) {
                if(Object.hasOwn(response.data, 'formData') )
                {
                   if(Object.hasOwn(response.data.formData[0], 'creator'))
                   { setClaimCreator(response.data.formData[0].creator);}

                   if(Object.hasOwn(response.data.formData[0], 'file_name'))
                   { setFileName(response.data.formData[0].file_name);}

                   if(Object.hasOwn(response.data.formData[0], 'isCompleted'))
                    { setIsCompleted(response.data.formData[0].isCompleted);}

                }


                setResponseFromGetApi(response.data.uploadedFiles);
                if (claimStatus !== "In-Progress")
                    hideLoader();
                else
                    hideInProgressLoader();
                if (Object.hasOwn(response.data, 'formData') && response.data.formData.length === 0) {
                    setShowClaimDetails(false);
                    if(alertRef.current)
                        alertRef.current.showSnackbar("No such claim found!", "error");
                    return;
                }
                if (response.data.status===0 && response.data.message==="Scope Mismatch. Unauthorized access to the claim") {
                    setShowClaimDetails(false);
                    if(alertRef.current)
                        alertRef.current.showSnackbar("You are not authorized to view the details of this claim!", "error");
                    return;
                }
                setGetApiResponse(response);
                setClaimStatus(response.data.formData[0].status);

                if ((response.data.formData[0].hasOwnProperty('version_id') && response.data.formData[0].version_id !== null))
                    setVersionId(response.data.formData[0].version_id);

                setCreator(response.data.formData[0].creator);
                if ((response.data.formData.length > 0) && response.data.formData[0].status !== "In-Progress") {
                    setShowSubmitButtons(false);
                    setShowAccordion(true);
                }
                else {
                    setShowSubmitButtons(true);
                    setShowAccordion(false);
                }
              
                if (calledFrom === "initialload") {
                    if (response.data.uploadedFiles.length > 0) {
                        const tempFileNames = response.data.uploadedFiles.map((item, index) => {
                            return item.split('/')[2];
                        }
                        )
                        setNamesOfFilesUploadedInSidebar(tempFileNames);
                    }
                    const versionNumber = Number(response.data.versionCount[0]);
                    let versions = [];
                    for (let i = 1; i <= versionNumber; i++) {
                        versions.push({ value: String(i), label: String(i) });
                    }
                    if (versions.length > 0) {
                        versions = versions.reverse();
                        setVersionOptions(versions);
                        setMaxVersion(versions[0]);
                        setVersionSelected(versions[0]);
                    }
                }
                if (response.data.formData.length !== 0) {
                    if (inputDcsRef.current.auditedClaim !== null) {
                        inputDcsRef.current.auditedClaim.value = response.data.formData[0].audited_claim_id
                    }
                    if (inputDcsRef.current.auditedClaimSeq !== null)
                        inputDcsRef.current.auditedClaimSeq.value = response.data.formData[0].audit_claim_seq
                    if (inputDcsRef.current.rxclaim_Instance !== null)
                        inputDcsRef.current.rxclaim_Instance.value = response.data.formData[0].rxclaim_Instance
                    if (inputDcsRef.current.adjustedClaim !== null)
                        inputDcsRef.current.adjustedClaim.value = response.data.formData[0].adjusted_claim_id
                    if (inputDcsRef.current.adjustedClaimSeq !== null)
                        inputDcsRef.current.adjustedClaimSeq.value = response.data.formData[0].adjusted_claim_seq
                    if (inputDcsRef.current.ClientFeeAndShareIndi !== null)
                        inputDcsRef.current.ClientFeeAndShareIndi.value = response.data.formData[0].client_fee_share_index
                    if (inputDcsRef.current.pharmacyAdjAmtInputField1 !== null)
                        inputDcsRef.current.pharmacyAdjAmtInputField1.value = response.data.formData[0].P1
                    if (inputDcsRef.current.pharmacyAdjAmtInputField2 !== null)
                        inputDcsRef.current.pharmacyAdjAmtInputField2.value = response.data.formData[0].P2
                    if (inputDcsRef.current.pharmacyAdjAmtInputFieldResult !== null)
                        inputDcsRef.current.pharmacyAdjAmtInputFieldResult.value = response.data.formData[0].pharmacy_adjusted_amount
                    if (inputDcsRef.current.ClientAdjAmtInputField1 !== null)
                        inputDcsRef.current.ClientAdjAmtInputField1.value = response.data.formData[0].C1
                    if (inputDcsRef.current.ClientAdjAmtInputField2 !== null)
                        inputDcsRef.current.ClientAdjAmtInputField2.value = response.data.formData[0].C2
                    if (inputDcsRef.current.ClientAdjAmtResult !== null)
                        inputDcsRef.current.ClientAdjAmtResult.value = response.data.formData[0].client_adjusted_amount
                    if (inputDcsRef.current.contactName !== null)
                        inputDcsRef.current.contactName.value = response.data.formData[0].contact_name
                    if (inputDcsRef.current.calls !== null)
                        inputDcsRef.current.calls.value = response.data.formData[0].call_count
                    if (inputDcsRef.current.emails !== null)
                        inputDcsRef.current.emails.value = response.data.formData[0].email_count
                    if (inputDcsRef.current.rts_report !== null) {
                        inputDcsRef.current.rts_report.value = response.data.formData[0].rts_report
                        if (response.data.formData[0].rts_report === null) {
                            inputDcsRef.current.rts_report.value = "Select RT or Report";
                        }
                    }
                    if (inputDcsRef.current.violation !== null) {
                        if (response.data.formData[0].violation === null) {
                            inputDcsRef.current.violation.value = "Select Violation";
                        }
                        else {
                            inputDcsRef.current.violation.value = response.data.formData[0].violation.toUpperCase();
                        }

                    }
                    if (inputDcsRef.current.claimReference !== null)
                        inputDcsRef.current.claimReference.value = response.data.formData[0].claim_reference_number
                    if (inputDcsRef.current.Sig !== null)
                        inputDcsRef.current.Sig.value = response.data.formData[0].sig
                    if (inputDcsRef.current.rOrr !== null)
                        inputDcsRef.current.rOrr.value = response.data.formData[0].rr
                    if (inputDcsRef.current.notes !== null)
                        inputDcsRef.current.notes.value = response.data.formData[0].notes
                    const validations = validate(inputsDcs);
                    if (Object.keys(validations).length !== 0) {
                        setIsFinalDecisionChecked(false);
                        const formattedMsg = Object.entries(validations).map(([key, value]) =>
                            `${value}`).join('\n');
                        setSnackBarForamttedMsg(formattedMsg);

                    }
                    setinputsDcsOfGetApi(
                        prevFormData => {
                            const newFormData = {
                                ...prevFormData,
                                auditedClaim: (response.data.formData[0].audited_claim_id === null) ? "" : response.data.formData[0].audited_claim_id,
                                auditedClaimSeq: (response.data.formData[0].audit_claim_seq === null) ? "" : response.data.formData[0].audit_claim_seq,
                                adjustedClaim: (response.data.formData[0].adjusted_claim_id === null) ? "" : response.data.formData[0].adjusted_claim_id,
                                adjustedClaimSeq: (response.data.formData[0].adjusted_claim_seq === null) ? "" : response.data.formData[0].adjusted_claim_seq,
                                rxclaim_Instance: (response.data.formData[0].rxclaim_Instance === null) ? "" : response.data.formData[0].rxclaim_Instance,
                                creationDate: (response.data.formData[0].creation_date === null) ? "" : response.data.formData[0].creation_date,
                                completionDate: (response.data.formData[0].claim_completion_date === null) ? "" : response.data.formData[0].claim_completion_date,
                                rts_report: (response.data.formData[0].rts_report === null) ? "Select RT or Report" : response.data.formData[0].rts_report,
                                violation: (response.data.formData[0].violation === null) ? "Select Violation" : response.data.formData[0].violation,
                                ClientFeeAndShareIndi: (response.data.formData[0].client_fee_share_index === null) ? "" : response.data.formData[0].client_fee_share_index,
                                pharmacyAdjAmtInputField1: (response.data.formData[0].P1 === null) ? "" : response.data.formData[0].P1,
                                pharmacyAdjAmtInputField2: (response.data.formData[0].P2 === null) ? "" : response.data.formData[0].P2,
                                pharmacyAdjAmtInputFieldResult: (response.data.formData[0].pharmacy_adjusted_amount === null) ? "" : response.data.formData[0].pharmacy_adjusted_amount,
                                ClientAdjAmtInputField1: (response.data.formData[0].C1 === null) ? "" : response.data.formData[0].C1,
                                ClientAdjAmtInputField2: (response.data.formData[0].C2 === null) ? "" : response.data.formData[0].C2,
                                ClientAdjAmtResult: (response.data.formData[0].client_adjusted_amount === null) ? "" : response.data.formData[0].client_adjusted_amount,
                                contactName: (response.data.formData[0].contact_name === null) ? "" : response.data.formData[0].contact_name,
                                calls: (response.data.formData[0].call_count === null) ? "" : response.data.formData[0].call_count,
                                emails: (response.data.formData[0].email_count === null) ? "" : response.data.formData[0].email_count,
                                claimReference: (response.data.formData[0].claim_reference_number === null) ? "" : response.data.formData[0].claim_reference_number,
                                Sig: (response.data.formData[0].sig === null) ? "" : response.data.formData[0].sig,
                                rOrr: (response.data.formData[0].rr === null) ? "" : response.data.formData[0].rr,
                                notes: (response.data.formData[0].notes === null) ? "" : response.data.formData[0].notes,
                            };
                            return newFormData;
                        });

                    setInputsDcs(
                        prevFormData => {
                            const newFormData = {
                                ...prevFormData,
                                auditedClaim: (response.data.formData[0].audited_claim_id === null) ? "" : response.data.formData[0].audited_claim_id,
                                auditedClaimSeq: (response.data.formData[0].audit_claim_seq === null) ? "" : response.data.formData[0].audit_claim_seq,
                                adjustedClaim: (response.data.formData[0].adjusted_claim_id === null) ? "" : response.data.formData[0].adjusted_claim_id,
                                adjustedClaimSeq: (response.data.formData[0].adjusted_claim_seq === null) ? "" : response.data.formData[0].adjusted_claim_seq,
                                rxclaim_Instance: (response.data.formData[0].rxclaim_Instance === null) ? "" : response.data.formData[0].rxclaim_Instance,
                                creationDate: (response.data.formData[0].creation_date === null) ? "" : response.data.formData[0].creation_date,
                                completionDate: (response.data.formData[0].claim_completion_date === null) ? "" : response.data.formData[0].claim_completion_date,
                                rts_report: (response.data.formData[0].rts_report === null) ? "" : response.data.formData[0].rts_report,
                                violation: (response.data.formData[0].violation === null) ? "" : response.data.formData[0].violation,
                                ClientFeeAndShareIndi: (response.data.formData[0].client_fee_share_index === null) ? "" : response.data.formData[0].client_fee_share_index,
                                pharmacyAdjAmtInputField1: (response.data.formData[0].P1 === null) ? "" : response.data.formData[0].P1,
                                pharmacyAdjAmtInputField2: (response.data.formData[0].P2 === null) ? "" : response.data.formData[0].P2,
                                pharmacyAdjAmtInputFieldResult: (response.data.formData[0].pharmacy_adjusted_amount === null) ? "" : response.data.formData[0].pharmacy_adjusted_amount,
                                ClientAdjAmtInputField1: (response.data.formData[0].C1 === null) ? "" : response.data.formData[0].C1,
                                ClientAdjAmtInputField2: (response.data.formData[0].C2 === null) ? "" : response.data.formData[0].C2,
                                ClientAdjAmtResult: (response.data.formData[0].client_adjusted_amount === null) ? "" : response.data.formData[0].client_adjusted_amount,
                                contactName: (response.data.formData[0].contact_name === null) ? "" : response.data.formData[0].contact_name,
                                calls: (response.data.formData[0].call_count === null) ? "" : response.data.formData[0].call_count,
                                emails: (response.data.formData[0].email_count === null) ? "" : response.data.formData[0].email_count,
                                claimReference: (response.data.formData[0].claim_reference_number === null) ? "" : response.data.formData[0].claim_reference_number,
                                Sig: (response.data.formData[0].sig === null) ? "" : response.data.formData[0].sig,
                                rOrr: (response.data.formData[0].rr === null) ? "" : response.data.formData[0].rr,
                                notes: (response.data.formData[0].notes === null) ? "" : response.data.formData[0].notes,
                            };
                            return newFormData;
                        });
                }
                const topScreenshotArray = response.data.topScreenshots.map((item, index) => {
                    const arrayObject = ["data:image/png;base64," + item];
                    return (
                        ["data:image/png;base64," + item]
                    )
                })
                if (topScreenshotArray.length === 0) {
                    setval([[]]);
                }
                else {
                    setval(topScreenshotArray);
                }
                const bottomScreenshotArray = response.data.bottomScreenshots.map((item, index) => {
                    const arrayObject = ["data:image/png;base64," + item];
                    return (
                        ["data:image/png;base64," + item]
                    )
                })
                if (bottomScreenshotArray.length === 0) {
                    setValBottom([[]]);
                }
                else {
                    setValBottom(bottomScreenshotArray);
                }
                setAreImagesChanged(false);
            }
        }
        catch (error) {
            hideInProgressLoader();
            hideLoader();
            AppInsight.trackEvent({ name: `PNA Frontend => callGetApiDocumentData Error, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }

    const [val, setval] = useState([[]]);
    const [valBottom, setValBottom] = useState([[]]);
    const [filesUploadedInSidebar, setFilesUploadedInSidebar] = useState([]);
    const [namesOfFilesUploadedInSidebar, setNamesOfFilesUploadedInSidebar] = useState([]);
    const [pkey, setPkey] = useState();
    const [version, setVersion] = useState();
    const [creationDate, setCreationDate] = useState();
    const [auditedClaimId, setAuditedClaimId] = useState();
    const [claimCompletionDate, setClaimCompletionDate] = useState();
    const [auditedClaimNumber, setAuditedClaimNumber] = useState();
    const [adjustedClaimNumber, setAdjustedClaimNumber] = useState();
    const [auditClaimSeq, setAuditClaimSeq] = useState();
    const [adjustedClaimSeq, setAdjustedClaimSeq] = useState();
    const [rxClaimInstance, setRxClaimInstance] = useState();
    const [clientAndFeeShareIndicator, setClientAndFeeShareIndicator] = useState();
    const [pharmacyAdjustedAmount, setPharmacyAdjustedAmount] = useState();
    const [claimAdjustedAmount, setAdjustedAmount] = useState();
    const [contactName, setContactName] = useState();
    const [RtOrReport, setRtOrReport] = useState();
    const [callCount, setCallCount] = useState();
    const [emailCount, setEmailCount] = useState();
    const [violation, setViolation] = useState();
    const [sig, setSig] = useState();
    const [rr, setRr] = useState();
    const [claimReferenceNumber, setClaimReferenceNumber] = useState();
    const [notes, setNotes] = useState();
    const [lastUpdateDate, setLastUpdateDate] = useState();
    const [status, setStatus] = useState();
    const [popupChange, setPopupChange] = useState(false);
    const uploadFileRef = useRef(null);
    const dispatch = useDispatch();

    const filesUploaded = useSelector((state) => {  //get data from the main store
        return state.documentClaim.uploadedFiles;
    })

    const formScreenshot = useSelector((state) => {
        return state.documentClaim.formScreenshot;
    })

    const calledFrom = useSelector((state) => {
        return state.documentClaim.calledFrom;
    })



    useEffect(() => {
    }, [formScreenshot])

    const updateValueAtIndex = (updatedValue, index) => {
        const newArray = [...val];
        newArray[index] = [updatedValue];
        setAreImagesChanged(true);
        setval(newArray);
        alertRef.current.handleClose();

    }
    const updateBottomValueAtIndex = (updatedValue, index) => {
        const newArrayBottom = [...valBottom];
        newArrayBottom[index] = [updatedValue];
        setAreImagesChanged(true);
        setValBottom(newArrayBottom);
        alertRef.current.handleClose();

    }
    const valueOfCommentScreenShot = (updatedValue, index) => {
        const newArray = [...commentScrnshot];
        newArray[index] = [updatedValue];
        setCommentScrnshot(newArray);
        alertRef.current.handleClose();
    }
    useEffect(() => {
    }, [versionOptions]);

    const handleAdd = () => {
        const temp = [...val, []]
        setval(temp);
        setAreImagesChanged(true);
    }

    const handleAddBottom = () => {
        const temp = [...valBottom, []]
        setValBottom(temp);
        setAreImagesChanged(true);
    }

    const handleDelete = (i) => {
        const temp = [...val];
        Swal.fire({
            text: "Are you sure you want to remove the above screenshot?",
            imageUrl:temp[i] ,
            showCancelButton: true,
            confirmButtonColor: "#002677",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!",
            customClass:{
                image:'img-padding'
            }
          }).then((result) => {
            if (result.isConfirmed) {
                temp.splice(i, 1);
                setval(temp);
                setAreImagesChanged(true);
            }
          });

    }

    const handleDeleteBottom = (i) => {
        const temp = [...valBottom];
        Swal.fire({
            text: "Are you sure you want to remove the above screenshot?",
            imageUrl:temp[i] ,
            // icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#002677",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            customClass:{
                image:'img-padding'
            }
          }).then((result) => {
            if (result.isConfirmed) {
                temp.splice(i, 1);
                setValBottom(temp);
                setAreImagesChanged(true);
            }
          });
       
    }

    const handleAddBetween = (index) => {
        const temp = [...val.slice(0,index),[],
    ...val.slice(index)];
        setval(temp);
        setAreImagesChanged(true);
    }

    const handleAddBetweenBottom = (index) => {
        const temp = [...valBottom.slice(0,index),[],
    ...valBottom.slice(index)];
        setValBottom(temp);
        setAreImagesChanged(true);
    }


    const handleRemoveUploadFile = (i) => {
        try {
            callRemoveUploadFile(i);
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error =>handleRemoveUploadFile, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }
    const callRemoveUploadFile = async (i) => {
        const token = getToken();
        const header = {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        };
        const deletedFileName = namesOfFilesUploadedInSidebar[i];
        setDeletedUploadFileName(deletedFileName);
        const uploadedGetFilesFromApi = responseFromGetApi.map(item => {
            const parts = item.split("uploadedFiles/");
            return parts.length > 1 ? parts[1] : '';
        });
        const valueCheck = uploadedGetFilesFromApi.includes(deletedFileName);
        if (valueCheck === true) {
            const result = await Swal.fire({
                title: "<small>Are you sure? you want to delete below uploaded file?</small>",
                text: "" + deletedFileName + "",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            })
            if (result.isConfirmed) {

                const temp = [...namesOfFilesUploadedInSidebar];
                temp.splice(i, 1);
                setNamesOfFilesUploadedInSidebar(temp);
                uploadFileRef.current.value = null;
                try {
                    const deleteUploadFilesStruct = {
                        "data": [
                            {
                                "pkey": params.pkey,
                                "filename": "" + deletedFileName + "",
                            }
                        ]
                    }
                    AppInsight.trackEvent({ name: `PNA Frontend=>callRemoveUploadFile API Call started, msid=> ${msid}`});
                    const response = await axios.post(process.env.REACT_APP_API_URI + "FileDelete", deleteUploadFilesStruct, header);
                    AppInsight.trackEvent({ name: `PNA Frontend=>callRemoveUploadFile Before API call completed, msid=> ${msid}`});
                    if (response.data.status === 204) {
                        setAreUploadFilesDeleted(true);
                        Swal.fire({
                            title: "Deleted!",
                            text: "Your file has been deleted.",
                            icon: "success"
                        });
                    }
                }
                catch (error) {
                    AppInsight.trackEvent({ name: `PNA Frontend =>Error =>callRemoveUploadFile, msid=> ${msid}`, properties: { errorMessage: error.message } });
                }
            };
        }
        else {

            const temp1 = filesUploadedInSidebar.filter(fileName => fileName.name !== deletedFileName)
            setFilesUploadedInSidebar(temp1);
            const temp = [...namesOfFilesUploadedInSidebar];
            temp.splice(i, 1);
            setNamesOfFilesUploadedInSidebar(temp);
            uploadFileRef.current.value = null;
        }
    }


    const clickUploadFileRef = () => {
        uploadFileRef.current.click();
    };

    const handleInputFileChange=(e)=>{
        handleUploadedFilesSidebar(e.target.files);
    }
    


    const handleUploadedFilesSidebar = (event) => {
        alertRef.current.handleClose();
        const files = Array.from(event);
        files.map((item, index) => {
            if (namesOfFilesUploadedInSidebar.includes(item.name)) {
                files.splice(index, 1);
            }
        })
        setFilesUploadedInSidebar(prev => [...prev, ...files]);
        const fileNames = files.map((item, index) => {
            return item.name;
        }
        )
        setNamesOfFilesUploadedInSidebar(prev => [...prev, ...fileNames]);
    }

    const submitDocumentClaimData = async (calledFrom, managerAction) => {
        try {
            const {isCorrupted, section}  = await corruptImgCheck()
            if (!isCorrupted) {
                if (buttonClicked.current) return;
                buttonClicked.current = true;
                callClaimsDocumentPageAPI(calledFrom, managerAction);
                // buttonClicked.current=false;
            }
            else {
                if (alertRef.current)
                    alertRef.current.showSnackbar(`Image(s) are corrupted in ${section} section`, "error");
            }
        }
        catch (error) {
            if (alertRef.current)
                alertRef.current.showSnackbar();
            buttonClicked.current = false;
            hideLoader();
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error =>submitDocumentClaimData, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }
    const callClaimsDocumentPageAPI = async (calledFrom, managerAction) => {
        checkCallNotesChangeFlag();
        let imageDom="";
        const token = getToken();
        try{
        //     const dpr= window.devicePixelRatio || 1;
        //     const zoomSize=String(Number(String(100/Number(dpr.toFixed(2)))).toFixed(0))+'%';
        
        //     const originalZoom=document.body.style.zoom;
        //     const originalHeight=document.body.style.height;
        //     const originalWidth=document.body.style.width;
        //     document.body.style.height='auto';
        //     document.body.style.width='1500px';
        //     document.body.style.zoom=zoomSize;
        

        //     requestAnimationFrame(async () => {
        //     imageDom= await htmlToImage.toPng(formRef.current);
        //     document.body.style.zoom=originalZoom;
        //     document.body.style.height=originalHeight;
        //     document.body.style.width=originalWidth;
        // })
   


        }

        catch(error)
        {
            hideLoader();
            buttonClicked.current=false;
        }
        if ((calledFrom === "updateClaim"&&claimStatus!=="Fallout") || calledFrom === "saveOrSubmit") {
            if (!(calledFrom === "saveOrSubmit" && isFinalDecisionChecked === true)) {

                if (callNotesChanged === false && areImagesChanged === false && filesUploadedInSidebar.length === 0 && areUploadFilesDeleted === false) {
                    if(alertRef.current)
                        alertRef.current.showSnackbar((
                        <CustomMessage>
                            You have not made any changes,you cannot proceed further.
                        </CustomMessage>
                    ), "error");
                    buttonClicked.current=false;
                    return;
                }

            }
        }

        if(calledFrom==="updateClaim"&&isUpdateClaimChecked===false){
            if (callNotesChanged === false && areImagesChanged === false && filesUploadedInSidebar.length === 0 && areUploadFilesDeleted === false) {
                if(alertRef.current)
                    alertRef.current.showSnackbar((
                    <CustomMessage>
                        You have not made any changes,you cannot proceed further.
                    </CustomMessage>
                ), "error");
                buttonClicked.current=false;
                return;
            }
        }

        if (calledFrom === "updateClaim"&&claimStatus!=="Fallout") {
            if (rxWebCallNotesChanged && isUpdateClaimChecked === false) {
                if (commentRef.current.commentData.value !== "") {
                    if(alertRef.current)
                        alertRef.current.showSnackbar((
                        <CustomMessage>
                            You have changed in call notes but not checked<br /> the checkbox, you cannot proceed further.
                        </CustomMessage>
                    ), "error");
                    buttonClicked.current=false;
                }
                else {
                    setCommentError(true);
                    if(alertRef.current)
                        alertRef.current.showSnackbar((
                        <CustomMessage>
                            You have changed in call notes but not checked<br /> the checkbox, you cannot proceed further. <div >Please enter comment to proceed</div>
                        </CustomMessage>
                    ), "error");
                    buttonClicked.current=false;

                }
                buttonClicked.current=false;
                return;
            }
        }
        if (calledFrom !== "saveOrSubmit") {
            if (commentRef.current.commentData.value === "") {
                setCommentError(true);
                if(alertRef.current)
                    alertRef.current.showSnackbar("Please enter comment to proceed.", "error");
                buttonClicked.current=false;
                return;
            }

        }

        if (!isFinalDecisionChecked) {
            const isValidationPresent = handleSaveAndContinueValidations();
            if (isValidationPresent)
                return;
        }
        if (claimStatus !== "In-Progress")
            showLoader();
        else
            showInProgressLoader();

            let expectedStatus="";
            if(isCompleted==="0"&&claimStatus==="Fallout")
                {
                  if(callNotesChanged===false&&areImagesChanged===false)
                    {
                        if(calledFrom==="updateClaim"&&isUpdateClaimChecked===true)
                            expectedStatus="Completed";                       
                        else if(calledFrom==="updateClaim"&&isUpdateClaimChecked===false)
                            expectedStatus="In-Progress"                          
                    }
                  else
                    {
                        if(calledFrom==="updateClaim"&&isUpdateClaimChecked===true)
                            expectedStatus="Completed";                       
                        else
                            expectedStatus="In-Progress"                          
                    }    
                }   
     
                let f_status="";
                if(isCompleted==="0"&&claimStatus==="Fallout")
                    {
                     f_status="3";
                    }
                else
                    {
                    f_status=(isFinalDecisionChecked) ? "0" : ((claimStatus !== "In-Progress") ? "0" :"1")
                    }       
         

        const header = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        };

        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = String(date.getFullYear());
        const hour = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        inputsDcs.completionDate = `${month}-${day}-${year}   ${hour}:${min}`;
        inputsDcsOfGetApi.completionDate = `${month}-${day}-${year}   ${hour}:${min}`;
        const documentClaimObject = {
            topScreenshots: [val.reduce((acc, item, index) => {
                if (item[0] !== undefined)
                    acc[index + 1] = item[0].slice(22, item[0].length);
                return acc;

            }, {})],
            bottomScreenshots: [valBottom.reduce((acc, item, index) => {
                if (item[0] !== undefined)
                    acc[index + 1] = item[0].slice(22, item[0].length);
                return acc;
            }, {})],
            // formDataScreenshot: [{ "1": (imageDom!=="")?imageDom.slice(22, imageDom.length):"" }],

            commentScreenshot:(commentScrnshot[0].length !== 0)? [
                
                {
                    "1": (commentScrnshot[0].length !== 0) ? commentScrnshot[0][0].slice(22, commentScrnshot[0][0].length) : ""
                }
            ]:[],
            "formData": [
                {
                    key: (params.pkey != undefined) ? params.pkey : "",
                    version: (getApiResponse !== null && getApiResponse.data.versionCount[0] !== 'None') ? ((managerAction === "") ? Number(getApiResponse.data.versionCount[0]) + 1 : Number(getApiResponse.data.versionCount[0])) : 1,
                    rxclaim_Instance: (inputDcsRef.current.rxclaim_Instance !== null) ? inputDcsRef.current.rxclaim_Instance.value : "",
                    audited_claim_number: (inputDcsRef.current.auditedClaim !== null) ? inputDcsRef.current.auditedClaim.value : "",
                    adjusted_claim_number: (inputDcsRef.current.adjustedClaim !== null) ? inputDcsRef.current.adjustedClaim.value : "",
                    audit_claim_seq: (inputDcsRef.current.auditedClaimSeq !== null) ? inputDcsRef.current.auditedClaimSeq.value : "",
                    adjusted_claim_seq: (inputDcsRef.current.adjustedClaimSeq !== null) ? inputDcsRef.current.adjustedClaimSeq.value : "",
                    ClientAndFeeShareIndicator: (inputDcsRef.current.ClientFeeAndShareIndi !== null) ? inputDcsRef.current.ClientFeeAndShareIndi.value : "",
                    P1: (inputDcsRef.current.pharmacyAdjAmtInputField1 !== null) ? inputDcsRef.current.pharmacyAdjAmtInputField1.value : "",
                    P2: (inputDcsRef.current.pharmacyAdjAmtInputField2 !== null) ? inputDcsRef.current.pharmacyAdjAmtInputField2.value : "",
                    PharmacyAdjustedAmount: (inputDcsRef.current.pharmacyAdjAmtInputFieldResult !== null) ? inputDcsRef.current.pharmacyAdjAmtInputFieldResult.value : "",
                    C1: (inputDcsRef.current.ClientAdjAmtInputField1 !== null) ? inputDcsRef.current.ClientAdjAmtInputField1.value : "",
                    C2: (inputDcsRef.current.ClientAdjAmtInputField2 !== null) ? inputDcsRef.current.ClientAdjAmtInputField2.value : "",
                    ClaimAdjustedAmount: (inputDcsRef.current.ClientAdjAmtResult !== null) ? inputDcsRef.current.ClientAdjAmtResult.value : "",
                    ContactName: (inputDcsRef.current.contactName !== null) ? inputDcsRef.current.contactName.value.trim() : "",
                    RTOrReport: (inputDcsRef.current.rts_report !== null) ? ((inputDcsRef.current.rts_report.value !== "Select RT or Report") ? inputDcsRef.current.rts_report.value : "") : "",
                    NumberOfCalls: (inputDcsRef.current.calls !== null) ? inputDcsRef.current.calls.value : "",
                    NumberOfEmails: (inputDcsRef.current.emails !== null) ? inputDcsRef.current.emails.value : "",
                    Violation: (inputDcsRef.current.violation !== null) ? (inputDcsRef.current.violation.value !== "Select Violation" ? inputDcsRef.current.violation.value : "") : "",
                    Sig: (inputDcsRef.current.Sig !== null) ? inputDcsRef.current.Sig.value.trim() : "",
                    "R/R": (inputDcsRef.current.rOrr !== null) ? inputDcsRef.current.rOrr.value.trim() : "",
                    ClaimReferenceNumber: (inputDcsRef.current.claimReference !== null) ? inputDcsRef.current.claimReference.value : "",
                    Notes: (inputDcsRef.current.notes !== null) ? inputDcsRef.current.notes.value.trim() : "",
                    last_update_date: formatDate(new Date()),
                    creator: msid,
                    claim_creator: claimCreator,
                    status: f_status,
                    claim_status: claimStatus,
                    role: (userRole === 1||userRole===3) ? "manager" : "auditor",
                    update_image_flag: (areImagesChanged) ? "1" : "0",
                    update_call_notes_flag: (rxWebCallNotesChanged) ? "1" : "0",
                    version_id: versionId,
                    is_new_version_required:(callNotesChanged===true||areImagesChanged===true||filesUploadedInSidebar.length !== 0||areUploadFilesDeleted===true)?"Yes":"No",
                    is_file_change:(filesUploadedInSidebar.length !== 0||areUploadFilesDeleted===true)?"Yes":"No",
                    expected_status:expectedStatus,        
                }
            ],
            commentData: [
                {
                    comment: (calledFrom !== "saveOrSubmit") ? commentRef.current.commentData.value : "",
                    manager_action: managerAction,
                }
            ]
        }
        const formData = new FormData();

        for (let i = 0; i < filesUploadedInSidebar.length; i++) {
            formData.append('documents', filesUploadedInSidebar[i]);

        }
        formData.append('data', JSON.stringify(documentClaimObject));
        
        try {
            // throw new Error("test");
            AppInsight.trackEvent({ name: `PNA Frontend=>callClaimsDocumentPageAPI API Call started, msid=> ${msid}`});
            const response = await axios.post(process.env.REACT_APP_API_URI + "ClaimsDocumentPage", formData, header);
            AppInsight.trackEvent({ name: `PNA Frontend=>callClaimsDocumentPageAPI API Call completed, msid=> ${msid}`});
            if (response.status === 200) {
                if (claimStatus !== "In-Progress") {
                    hideLoader();
                    commentRef.current.commentData.value = "";
                    setCommentScrnshot([[]]);
                }
                else {
                    hideInProgressLoader();
                }
                setFilesUploadedInSidebar([]);
                setAreUploadFilesDeleted(false);
                if (response.data.status === '1') {
                    if (isFinalDecisionChecked) {
                        setShowSubmitButtons(false);
                        setShowAccordion(true);
                    }
                    callGetApiDocumentData(0, "initialload", params.pkey, msid);
                    handleGetApiComment();
                    if(alertRef.current)
                        alertRef.current.showSnackbar("Changes have been saved successfully", "success");
                    buttonClicked.current=false;
                }
                else {
                    if (response.data.hasOwnProperty('error') && response.data.error === 'Fallout') {
                        callGetApiDocumentData(0, "initialload", params.pkey, msid);
                        handleGetApiComment();
                        if(alertRef.current)
                            alertRef.current.showSnackbar(response.data.message, "error");
                        buttonClicked.current=false;

                    }
                    else {
                        if(alertRef.current){
                            if(response.data.hasOwnProperty('error') && response.data.error !== ""){
                                if(response.data.error==="Pending Review"){
                                    handleGetApiComment();
                                    alertRef.current.showSnackbar('Some error has occurred. Due to some failure from RxClaim end, data is not pushed to RxClaim and RxWeb.',"error"); 
                                }
                                else
                                    alertRef.current.showSnackbar('Some error has occurred.'+response.data.error+'.\n'+'Do not leave this page or click on refresh until you have clicked on "Download Documents" or you will lose your data.',"error");

                            }
                            buttonClicked.current=false;
                     }}
                 }
                setIsUpdateClaimChecked(false);
            }
            
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar('Some error has occurred.  Do not leave this page or click on refresh until you have clicked on "Download Documents" or you will lose your data.',"error");
            buttonClicked.current=false;
            hideLoader();
            hideInProgressLoader();
            AppInsight.trackEvent({ name: `PNA Frontend => callClaimsDocumentPageAPI Error, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }
    const handleChangeComments = (e) => {
        alertRef.current.handleClose();
        setCommentError(false);
    }
    const handleChangeDcs = (e, calledFrom) => {
        const { value, name } = e.target;
        alertRef.current.handleClose();
        const sigRRExp = /[^a-zA-Z0-9.,\/\-+()%=\\<>#*\[\]~{}@?!:|\n $]/g
        const feeShareAndNotesExp = /[^a-zA-Z0-9.,\/\-+()%'"=\\<>#*&\[\]~{}@?!:;|\n ]/g
        const NotesExp = /[^a-zA-Z0-9.,\/\-+()%'"=\\<>#*&\[\]~{}@?!:;|\n $]/g


        if (name === 'calls' || name === 'emails') {
            if (!/^\d*$/.test(value) || value.length > 5) {
                if (name === 'emails') {
                    inputDcsRef.current.emails.value = inputDcsRef.current.emails.value.replace(/[^0-9]/g, "");
                    return;
                }
                if (name === 'calls') {
                    inputDcsRef.current.calls.value = inputDcsRef.current.calls.value.replace(/[^0-9]/g, "");
                    return;
                }
            }
        };
        if (name === 'adjustedClaim' || name === "claimReference") {
            if (!/^\d*$/.test(value) || value.length > 15) {
                if (name === 'adjustedClaim') {
                    inputDcsRef.current.adjustedClaim.value = inputDcsRef.current.adjustedClaim.value.replace(/[^0-9]/g, "");
                }
                if (name === 'claimReference') {
                    inputDcsRef.current.claimReference.value = inputDcsRef.current.claimReference.value.replace(/[^0-9]/g, "");
                }
                return;
            }
        };
        if (name === 'adjustedClaimSeq') {
            if (!/^\d*$/.test(value) || value.length > 10) {
                inputDcsRef.current.adjustedClaimSeq.value = inputDcsRef.current.adjustedClaimSeq.value.replace(/[^0-9]/g, "");
                return;
            }
        };
        if (name === "ClientFeeAndShareIndi") {
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                inputDcsRef.current.ClientFeeAndShareIndi.value = inputDcsRef.current.ClientFeeAndShareIndi.value.replace(feeShareAndNotesExp, "");
                return;
            }
        }
        if (name === "contactName") {
            if (!/^[a-zA-Z/, ]*$/.test(value) || value.trim().length > 50) {
                inputDcsRef.current.contactName.value = inputDcsRef.current.contactName.value.replace(/[^a-zA-Z/, ]/g, "");
                return;
            }
        }
        if (name === "Sig") {
            if (!/^[a-zA-Z0-9\n ]*$/.test(value) || value.trim().length > 150) {
                inputDcsRef.current.Sig.value = inputDcsRef.current.Sig.value.replace(sigRRExp, "");
                return;
            }
        }
        if (name === "rOrr") {
            if (!/^[a-zA-Z0-9/\n ]*$/.test(value) || value.trim().length > 150) {
                inputDcsRef.current.rOrr.value = inputDcsRef.current.rOrr.value.replace(sigRRExp, "");
            }
        }
        if (name === "notes") {
            if (!/^[a-zA-Z0-9/\n ]*$/.test(value) || value.trim().length > 150) {
                inputDcsRef.current.notes.value = inputDcsRef.current.notes.value.replace(NotesExp, "");
            }
        }
        let lengthAfterDecimal=0;
            let lengthAfterDecimal1=0;
            let lengthAfterDecimalClient=0;
            let lengthAfterDecimalClient1=0;


        if (name === 'pharmacyAdjAmtInputField1' || name === 'pharmacyAdjAmtInputField2') {
            

            lengthAfterDecimal=(inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1]?.length):0;
            lengthAfterDecimal1=(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]?.length):0;


            if (!/^$|^-?\d+(\.\d+)?$/.test(value) || value.length > 30) {
                if (name === 'pharmacyAdjAmtInputField1') {
                   
                    inputDcsRef.current.pharmacyAdjAmtInputField1.value = inputDcsRef.current.pharmacyAdjAmtInputField1.value.replace(/[^0-9.-]/g, "").replace(/(\..*)\./g,"$1").replace(/^\./,"").replace(/^-(?=\.)/,"-0");
                    lengthAfterDecimal=(inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1]?.length):0;

                    const count = (inputDcsRef.current.pharmacyAdjAmtInputField1.value.match(/-/g) || []).length;
                    if (count > 1 || (count === 1 && inputDcsRef.current.pharmacyAdjAmtInputField1.value.indexOf('-') !== 0)) {
                        let firstMinusPresent = false;

                        if (inputDcsRef.current.pharmacyAdjAmtInputField1.value[0] === '-')
                            firstMinusPresent = true;

                        inputDcsRef.current.pharmacyAdjAmtInputField1.value = inputDcsRef.current.pharmacyAdjAmtInputField1.value.replace(/-/g, "");

                        if (firstMinusPresent)
                            inputDcsRef.current.pharmacyAdjAmtInputField1.value = '-' + inputDcsRef.current.pharmacyAdjAmtInputField1.value;
                    }

                    lengthAfterDecimal=(inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1]?.length):0;
                    return;
                }

                lengthAfterDecimal1=(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]?.length):0;
                if (name === 'pharmacyAdjAmtInputField2') {
                    inputDcsRef.current.pharmacyAdjAmtInputField2.value = inputDcsRef.current.pharmacyAdjAmtInputField2.value.replace(/[^0-9.-]/g, "").replace(/(\..*)\./g,"$1").replace(/^\./,"").replace(/^-(?=\.)/,"-0");
                   
                    lengthAfterDecimal1=(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]?.length):0;
                    const count = (inputDcsRef.current.pharmacyAdjAmtInputField2.value.match(/-/g) || []).length;
                    if (count > 1 || (count === 1 && inputDcsRef.current.pharmacyAdjAmtInputField2.value.indexOf('-') !== 0)) {
                        let firstMinusPresent = false;

                        if (inputDcsRef.current.pharmacyAdjAmtInputField2.value[0] === '-')
                            firstMinusPresent = true;

                        inputDcsRef.current.pharmacyAdjAmtInputField2.value = inputDcsRef.current.pharmacyAdjAmtInputField2.value.replace(/-/g, "");

                        if (firstMinusPresent)
                            inputDcsRef.current.pharmacyAdjAmtInputField2.value = '-' + inputDcsRef.current.pharmacyAdjAmtInputField2.value;


                    }
                    lengthAfterDecimal1=(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1]?.length):0;
                    return;
                }
            }

            if(inputDcsRef.current.pharmacyAdjAmtInputField1.value.includes("."))
            {
                inputDcsRef.current.pharmacyAdjAmtInputField1.value=inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[0]+"."+inputDcsRef.current.pharmacyAdjAmtInputField1.value.split('.')[1].slice(0,2);
            }

            if(inputDcsRef.current.pharmacyAdjAmtInputField2.value.includes("."))
            {
                inputDcsRef.current.pharmacyAdjAmtInputField2.value=inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[0]+"."+inputDcsRef.current.pharmacyAdjAmtInputField2.value.split('.')[1].slice(0,2);
            }
        }
        if (name === 'ClientAdjAmtInputField1' || name === 'ClientAdjAmtInputField2') {

            lengthAfterDecimalClient=(inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1]!==undefined)?(inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1]?.length):0;
            lengthAfterDecimalClient1=(inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1]?.length):0;
            if (!/^$|^-?\d+(\.\d+)?$/.test(value) || value.length > 30) {
                if (name === 'ClientAdjAmtInputField1') {
                    inputDcsRef.current.ClientAdjAmtInputField1.value = inputDcsRef.current.ClientAdjAmtInputField1.value.replace(/[^0-9.-]/g, "").replace(/(\..*)\./g,"$1").replace(/^\./,"").replace(/^-(?=\.)/,"-0");
                   
                    lengthAfterDecimalClient=(inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1]!==undefined)?(inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1]?.length):0;                   
                    const count = (inputDcsRef.current.ClientAdjAmtInputField1.value.match(/-/g) || []).length;
                    if (count > 1 || (count === 1 && inputDcsRef.current.ClientAdjAmtInputField1.value.indexOf('-') !== 0)) {
                        let firstMinusPresent = false;

                        if (inputDcsRef.current.ClientAdjAmtInputField1.value[0] === '-')
                            firstMinusPresent = true;

                        inputDcsRef.current.ClientAdjAmtInputField1.value = inputDcsRef.current.ClientAdjAmtInputField1.value.replace(/-/g, "");

                        if (firstMinusPresent)
                            inputDcsRef.current.ClientAdjAmtInputField1.value = '-' + inputDcsRef.current.ClientAdjAmtInputField1.value;

                            //getImage();
                    }
                    lengthAfterDecimalClient=(inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1]!==undefined)?(inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1]?.length):0;
                   
                    return;
                }
                if (name === 'ClientAdjAmtInputField2') {
                    inputDcsRef.current.ClientAdjAmtInputField2.value = inputDcsRef.current.ClientAdjAmtInputField2.value.replace(/[^0-9.-]/g, "").replace(/(\..*)\./g,"$1").replace(/^\./,"").replace(/^-(?=\.)/,"-0");
                    lengthAfterDecimalClient1=(inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1]?.length):0;
                    const count = (inputDcsRef.current.ClientAdjAmtInputField2.value.match(/-/g) || []).length;
                    if (count > 1 || (count === 1 && inputDcsRef.current.ClientAdjAmtInputField2.value.indexOf('-') !== 0)) {
                        let firstMinusPresent = false;

                        if (inputDcsRef.current.ClientAdjAmtInputField2.value[0] === '-')
                            firstMinusPresent = true;

                        inputDcsRef.current.ClientAdjAmtInputField2.value = inputDcsRef.current.ClientAdjAmtInputField2.value.replace(/-/g, "");

                        if (firstMinusPresent)
                            inputDcsRef.current.ClientAdjAmtInputField2.value = '-' + inputDcsRef.current.ClientAdjAmtInputField2.value;


                    }
                    lengthAfterDecimalClient1=(inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1]!==undefined)?(inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1]?.length):0;
                    return;
                }
            }
       
            if(inputDcsRef.current.ClientAdjAmtInputField1.value.includes("."))
            {
                inputDcsRef.current.ClientAdjAmtInputField1.value=inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[0]+"."+inputDcsRef.current.ClientAdjAmtInputField1.value.split('.')[1].slice(0,2);
            }

            if(inputDcsRef.current.ClientAdjAmtInputField2.value.includes("."))
            {
                inputDcsRef.current.ClientAdjAmtInputField2.value=inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[0]+"."+inputDcsRef.current.ClientAdjAmtInputField2.value.split('.')[1].slice(0,2);
            }
        }

        if (name === 'pharmacyAdjAmtInputField1' || name === 'pharmacyAdjAmtInputField2') {
            const input1=Number(inputDcsRef.current.pharmacyAdjAmtInputField1.value) || 0;
            const input2 = Number(inputDcsRef.current.pharmacyAdjAmtInputField2.value) || 0;
            const maxValue=Math.max(lengthAfterDecimal,lengthAfterDecimal1);
            inputDcsRef.current.pharmacyAdjAmtInputFieldResult.value = Number(Number(input1 - input2).toFixed(2));
        }
        if (name === 'ClientAdjAmtInputField1' || name === 'ClientAdjAmtInputField2') {
            const input1 = Number(inputDcsRef.current.ClientAdjAmtInputField1.value) || 0;
            const input2 = Number(inputDcsRef.current.ClientAdjAmtInputField2.value) || 0;
            const maxValue1=Math.max(lengthAfterDecimalClient,lengthAfterDecimalClient1);
            inputDcsRef.current.ClientAdjAmtResult.value =Number(Number(input1 - input2).toFixed(2));
        }
        const validations = validate(inputsDcs);
        if (Object.keys(validations).length !== 0) {
            setIsFinalDecisionChecked(false);
            const formattedMsg = Object.entries(validations).map(([key, value]) =>
                `${value}`).join('\n');
            setSnackBarForamttedMsg(formattedMsg);
        }
        if (calledFrom === "onBlur") {
            setInputsDcs(
                prevFormData => {
                    const newFormData = {
                        ...prevFormData,
                        [name]: value
                    };
                    if (name === 'pharmacyAdjAmtInputField1' || name === 'pharmacyAdjAmtInputField2') {
                        const input1 = Number(newFormData.pharmacyAdjAmtInputField1) || 0;
                        const input2 = Number(newFormData.pharmacyAdjAmtInputField2) || 0;
                        const maxValue=Math.max(lengthAfterDecimal,lengthAfterDecimal1);
                        newFormData.pharmacyAdjAmtInputFieldResult = Number(Number(input1 - input2).toFixed(maxValue));
                    }

                    if (name === 'ClientAdjAmtInputField1' || name === 'ClientAdjAmtInputField2') {
                        const input1 = Number(newFormData.ClientAdjAmtInputField1) || 0;
                        const input2 = Number(newFormData.ClientAdjAmtInputField2) || 0;
                        const maxValue1=Math.max(lengthAfterDecimalClient,lengthAfterDecimalClient1);
                        newFormData.ClientAdjAmtResult = Number(Number(input1 - input2).toFixed(maxValue1));
                    }
                    return newFormData;
                });
        }
        setFormErrors({ ...formErrors, [e.target.name]: '' });

    };
    const [options, setOption] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    // useEffect(() => {
    //     handleGetApiCall();
    // }, []);

    const handleGetApiCall = async () => {
        try {
            callDropDownBindAPI();
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error => handleGetApiCall, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    };
    const callDropDownBindAPI = async () => {
        try {
            const token = getToken();
            const header = {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            };
            AppInsight.trackEvent({ name: `PNA Frontend=>callDropDownBindAPI API Call started, msid=> ${msid}`});
            const rawResponse = await axios.get(
                process.env.REACT_APP_API_URI + "DropdownBind", header
            );
            AppInsight.trackEvent({ name: `PNA Frontend=>callDropDownBindAPI API Call completed, msid=> ${msid}`});
            setOption(rawResponse.data.violationList);
        }
        catch (error) {
            if(alertRef.current)
                alertRef.current.showSnackbar();
            AppInsight.trackEvent({ name: `PNA Frontend => callDropDownBindAPI Error, msid=> ${msid}`, properties: { errorMessage: error.message } });
        }
    }
    const handleChangeDropdown = (event) => {
        setSelectedOption(event.target.value);
    }
    const [show,setShow]=useState(true);
    const handleRequestForApproval=async(manager_action)=>{

        try {
            if(buttonClicked.current)return;
                buttonClicked.current=true;
            if(manager_action==="Request For Approval"&&(checkCallNotesChangeFlagSidebar() !== false || areImagesChanged !== false || filesUploadedInSidebar.length !== 0 || areUploadFilesDeleted !== false))
            {
                if(alertRef.current)
                    alertRef.current.showSnackbar("Please click on 'Save & Continue' to save the changes before requesting for approval.", "error");
                buttonClicked.current=false;
                return;
  
            }

            else if (commentRef.current.commentData.value === "") {
                setCommentError(true);
                if(alertRef.current)
                    alertRef.current.showSnackbar("Please enter comment to proceed.", "error");
                buttonClicked.current=false;
                return;
            }
            const dataStruct={
                "key": params.pkey,
                "audited_claim_number": inputDcsRef.current.auditedClaim.value,
                "creator": msid,
                "status": "2",
                "role": (userRole === 1||userRole===3) ? "manager" : "auditor",
                "comment": commentRef.current.commentData.value,
                "manager_action": ""+manager_action+""
            }
            const token = getToken();
            const header = {
              headers: {
                "Authorization": `Bearer ${token}`,
              },
            };
            showLoader();
            AppInsight.trackEvent({ name: `PNA Frontend=>handleRequestForApproval API Call started, msid=> ${msid}`});
            const response = await axios.post(
              process.env.REACT_APP_API_URI + "RequestForApproval",dataStruct, header
            );
            AppInsight.trackEvent({ name: `PNA Frontend=>handleRequestForApproval API Call completed, msid=> ${msid}`});
            if(response.status===200){
                hideLoader(); 
                if(response.data.status==="1"){
                handleGetApiComment();
                commentRef.current.commentData.value = "";
                setShow(false);
                setShowSubmitButtons(false);
                if(alertRef.current)   
                    alertRef.current.showSnackbar("Changes saved successfully",'success');
                buttonClicked.current=false;
                }
            }
          } catch (error) { 
            if(alertRef.current)
                alertRef.current.showSnackbar();
            buttonClicked.current=false;
            AppInsight.trackEvent({ name: `PNA Frontend => api token Error => handleRequestForApproval, msid=> ${msid}`, properties: { errorMessage: error.message } });
            hideLoader() 
        }

    }

    const handleViewHistoryPopup = () => {
        setShowHistoryPopup(true);
        setPopupChange(!popupChange);
    }

    const handleDragOver=(e)=>{
        e.preventDefault();
        setIsDragging(true);
  }
 
  const handleDrop=(e)=>{
      e.preventDefault();
      handleUploadedFilesSidebar(e.dataTransfer.files);
      setIsDragging(false);
  }

  const handleDragLeave=()=>{
      setIsDragging(false);

  }

  const [draggedItem, setDraggedItem]=useState(null);
  const [draggedItemContainerName, setDraggedItemContainerName]=useState(null);

  const dragScrnshot=(index,containerName)=>{
    setDraggedItem(index);
    setDraggedItemContainerName(containerName);
  }

  const dropScrnshot=(e,index)=>{
    if(draggedItemContainerName!=='upper'){
        if(alertRef.current)
            alertRef.current.showSnackbar('Unable to drop screenshot from bottom to top section','error');
        return;
    }
    const draggedItemIndex=draggedItem;
    const updatedImages=[...val];
    const draggedImage=updatedImages[draggedItemIndex];
    updatedImages.splice(draggedItemIndex, 1);
    updatedImages.splice(index, 0,draggedImage);

    setval(updatedImages);
    setDraggedItem(null);
    setAreImagesChanged(true);
    setDraggedItemContainerName(null);



  }

  const handleDragOverScrnshot=(e)=>{
    e.preventDefault();
  }



  const dropScrnshotBottom=(e, index)=>{
    if(draggedItemContainerName!=='bottom'){
        if(alertRef.current)
            alertRef.current.showSnackbar('Unable to drop screenshot from top to bottom section','error');
        return;
    }
    const draggedItemIndex=draggedItem;
    const updatedImages=[...valBottom];
    const draggedImage=updatedImages[draggedItemIndex];
    updatedImages.splice(draggedItemIndex, 1);
    updatedImages.splice(index, 0,draggedImage);

    setValBottom(updatedImages);
    setDraggedItem(null);
    setAreImagesChanged(true);
    setDraggedItemContainerName(null);



  }


  const downloadScreenshots=async()=>{
    let imageDom;
    try{
        const dpr= window.devicePixelRatio || 1;
        const zoomSize=String(Number(String(100/Number(dpr.toFixed(2)))).toFixed(0))+'%';
        
        const originalZoom=document.body.style.zoom;
        const originalHeight=document.body.style.height;
        const originalWidth=document.body.style.width;
        document.body.style.height='auto';
        document.body.style.width='1500px';
        document.body.style.zoom=zoomSize;
        
        await new Promise((resolve)=>setTimeout(resolve,300));
        imageDom= await htmlToImage.toPng(formRef.current);
        document.body.style.zoom=originalZoom;
        document.body.style.height=originalHeight;
        document.body.style.width=originalWidth;
   
    const zip=new JSZip();
    const folder=zip.folder("Form_screenshots");
    let topFolder;
    let bottomFolder;
    
    
    const base64data=imageDom.split(",")[1];
    folder.file(`Form_screenshot.png`,base64data,{base64:true});
        
    const flatVal=val.flat();
    const flatValBottom=valBottom.flat();

    flatVal.forEach((image,index)=>{
        if(index===0)
            topFolder= zip.folder("Top_screenshots");
        const base64data=image.split(",")[1];
        topFolder.file(`Top_screenshots${index+1}.png`,base64data,{base64:true});
    }); 

    flatValBottom.forEach((image,index)=>{
        if(index===0)
            bottomFolder=zip.folder("Bottom_screenshots");
        const base64data=image.split(",")[1];
        bottomFolder.file(`Bottom_screenshot${index+1}.png`,base64data,{base64:true});
       });

        zip.generateAsync({type:'blob'}).then((content)=>{
            saveAs(content,`${params.pkey}.zip`);
        })


    }

    catch(error)
    {
        if(alertRef.current)
            alertRef.current.showSnackbar();
        AppInsight.trackEvent({ name: `PNA Frontend  =>Error in downloadScreenshots, msid=> ${msid}`, properties: { errorMessage: error.message } });
 
    }


    
  }
 
 


    return (
        <>
            <div className="container" style={{ margin: '0px', padding: '0px' }}>
                {inProgressLoader}
                {loader}
                <div className="left-panel">
                <Sidebar defaultValue="DocumentClaim" isCallNotesChanged={isCallNotesChanged} checkCallNotes={checkCallNotesChangeFlagSidebar} areImagesChanged={areImagesChanged} filesUploadedInSidebar={filesUploadedInSidebar} areUploadFilesDeleted={areUploadFilesDeleted} />
                </div>
                <ViewHistoryPopup openViewHistory={showHistoryPopup} popupChange={popupChange} />
                <div className="right-panel">
                    <div id="main">
                        <TopBar role={role} />
                        {showClaimDetails &&
                            <div class="main-content container-fluid">
                                <section class="section" >
                                    <div class="row mb-1 sectionRowClass">
                                        <div class="col-md-4 paddingLeftRightZero backgroundColorBlue">
                                            <div class="card">
                                                <div class="card-header d-flex justify-content-start align-items-center borderRadiusZero">
                                                    <div className="versionStyle">Version</div>
                                                    <div className="versionDropdown">
                                                        <Select
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            value={versionSelected}
                                                            onChange={versionDropdownChange}
                                                            styles={versionStyles}
                                                            isSearchable={true}
                                                            name="color"
                                                            options={versionOptions}
                                                        />
                                                    </div>     <div class="d-flex ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 paddingLeftRightZero backgroundColorBlue">
                                            <div class="card">
                                                <div class="card-header d-flex justify-content-start align-items-center borderRadiusZero">
                                                    <h4 class="card-title paddingLeft"> Audited Claim# : {inputsDcs.auditedClaim} </h4>
                                                    {/* <h4 class="card-title paddingLeft_10">Completion / Last Updated Date & Time :  {(inputsDcs.completionDate !== null && inputsDcs.completionDate !== "") ? inputsDcs.completionDate : " "}</h4> */}
                                                    <div class="d-flex ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 paddingLeftRightZero backgroundColorBlue">
                                            <div class="card">
                                                <div class="card-header d-flex justify-content-end align-items-center borderRadiusZero paddingRight40">
                                                    <h4 class="card-title paddingLeft">Last Update Date & Time : {(inputsDcs.creationDate !== "") ? (" " + formatDateAndTime(inputsDcs.creationDate)) : "NA"} </h4>                                                <div class="d-flex ">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-2 sectionRowClass">
                                        <div class="col-md-8 paddingLeftRightZero">
                                            <div class="card">
                                            <div class="card-header d-flex justify-content-start align-items-center borderRadiusZero backgroundColorWhite">
                                                 FileName :  {fileName?fileName:'NA'}
                                            </div>
                                                
                                            </div>

                                        </div>
                                       
                                        <div class="col-md-4 paddingLeftRightZero">
                                            <div class="card">
                                            <div class="card-header d-flex justify-content-end align-items-center borderRadiusZero backgroundColorWhite paddingRight40">
                                                 Current Auditor :  {claimCreator}
                                            </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="container">
                                    <div class="sectionLeftDocumentClaim" style={{paddingRight:'1%'}} onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragLeave}>
                                                <div className="uploadIcon" >
                                                {!isDragging?( <div  className="svgUploadIcon" >
                                                    <svg  onClick={clickUploadFileRef} xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                                                    </svg>
                                                </div>):(<p>drop file(s) here</p>)}
                                            </div>
                                            <div class="browseandUploadFiles">Browse & Upload<br /> Files</div>
                                            <div> <input className="displayNone" type="file" onChange={handleInputFileChange} ref={uploadFileRef} multiple/></div>
                                            <div>
                                                <ul className="unorderedFileList">
                                                    {namesOfFilesUploadedInSidebar.map((item, index) => {
                                                        const uploadedGetFilesFromApi = responseFromGetApi.map(item => {
                                                            const parts = item.split("uploadedFiles/");
                                                            return parts.length > 1 ? parts[1] : '';
                                                        });
                                                        const valueCheck = uploadedGetFilesFromApi.includes(item);
                                                        return (
                                                            <div key={index}>
                                                                <li className={valueCheck ? "unorderedFileListItem cursorPointer displayInline" : "unorderedFileListItem displayInline"} onClick={() => handleDowloadFile(item, valueCheck)}>
                                                                   <span>&#8226; {item};</span> 
                                                            </li>
                                                                <button type="button" class="btn-close" aria-label="Close" style={{ marginLeft: "0px", display: 'inline' }} id={`btn-${index}`} onClick={() => handleRemoveUploadFile(index)}></button>
                                                            </div>
                                                        )
                                                    }
                                                    )
                                                    }
                                                </ul>
                                            </div>
                                          {(checkCallNotesChangeFlagSidebar()=== true||areImagesChanged===true)?<a onClick={downloadScreenshots} style={{color:"#002677",fontSize:"80%",textDecoration:'underline',cursor:'pointer',marginLeft:'5%',fontWeight:'700'}} >Download Documents</a>:''}

                                        </div>
                                        <div class="sectionRightDocumentClaim" id="select" style={{ borderColor: 'black' }}>
                                            <div class="documentClaimDataDiv">
                                                <div class="screenShotTop">
                                                    <div >
                                                        {val.map((data, i) => {

                                                            return (
                                                                <div >
                                                                     <div class="item" id={`item-${i}`}>
                                                                      {maxVersion.value===versionSelected.value? <button type="button" class="btn-close" aria-label="Close" id={`btn-${i}`} onClick={() => handleDelete(i)}></button>:''}
                                                                      
                                                                        <CopyPaste id={i} url={data[0]}  updateValueAtIndex={updateValueAtIndex} maxVersion={maxVersion} versionSelected={versionSelected} draggable={true} dragScrnshot={()=>dragScrnshot(i,'upper')} dropScrnshot={dropScrnshot} handleDragOverScrnshot={handleDragOverScrnshot} handleAdd={()=>handleAddBetween(i)} alertRef={alertRef}/>
            
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        )}
                                                    </div>
                                                    {maxVersion.value===versionSelected.value?<button onClick={() => handleAdd()} type="button" class="btn btn-primary darkBlue">Add Screenshot</button>:''}
                                                </div>
                                                <div ref={formRef} class="formClassMiddle">
                                                    <div>
                                                        <form className='cssDocumentClaimScreen7'>
                                                            <div class="form-row cssChange4 cssDocumentClaimScreen0">
                                                                <div class="col-md-4  cssChange">
                                                                    <label for="validationDefault01">Audited Claim #</label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control cssDocClaim1"
                                                                        //   id="validationDefault01"
                                                                        max='40'
                                                                        name="auditedClaim"
                                                                        //onChange={handleChangeDcs}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        // value={inputDcs.auditedClaim}
                                                                        ref={(el) => (inputDcsRef.current.auditedClaim = el)}
                                                                        readOnly
                                                                    />
                                                                </div>
                                                                <div class="col-md-4  cssChange cssChange1">
                                                                    <label for="validationDefault02">Audited Claim Seq</label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control cssDocClaim1"
                                                                        id="validationDefault02"
                                                                        maxlength="3"
                                                                        placeholder=""
                                                                        required
                                                                        name='auditedClaimSeq'
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.auditedClaimSeq = el)}
                                                                        readOnly
                                                                    />
                                                                </div>
                                                                <div class="col-md-3  cssChange cssChange1">
                                                                    <label for="validationDefaultUsername">
                                                                        RxClaim Instance
                                                                </label>
                                                                    <br></br>

                                                                    <input
                                                                        type="text"
                                                                        class="form-control cssDocClaim1"
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        name='adjustedClaim'
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.rxclaim_Instance = el)}
                                                                        readOnly
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-4  cssChange">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>Adjusted Claim #</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        name='adjustedClaim'
                                                                        maxlength="15"
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                        ref={(el) => (inputDcsRef.current.adjustedClaim = el)}
                                                                        style={{ borderColor: formErrors.adjustedClaim ? 'red' : '' }}

                                                                    />
                                                                </div>
                                                                <div class="col-md-4 cssChange cssChange1">
                                                                    <label for="validationDefault02"><sup className="colorRedFontBold" >*</sup>Adjusted Claim Seq</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault02"
                                                                        placeholder=""
                                                                        maxlength="3"
                                                                        required
                                                                        name='adjustedClaimSeq'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.adjustedClaimSeq = el)}
                                                                        style={{ borderColor: formErrors.adjustedClaimSeq ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}


                                                                    />
                                                                </div>
                                                                <div class="col-md-3  cssChange cssChange1 cssChange3">
                                                                    <label for="validationDefault02">
                                                                        <sup className="colorRedFontBold" >*</sup>Client & Fee Share (FS) Indicator
                                                                </label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault02"
                                                                        placeholder=""
                                                                        required
                                                                        name='ClientFeeAndShareIndi'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.ClientFeeAndShareIndi = el)}
                                                                        style={{ borderColor: formErrors.ClientFeeAndShareIndi ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* change */}
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-3  cssChange">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>Pharmacy Adj Amt</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        maxlength="15"
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}
                                                                        name='pharmacyAdjAmtInputField1'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.pharmacyAdjAmtInputField1 = el)}
                                                                        style={{ borderColor: formErrors.pharmacyAdjAmtInputField1 ? 'red' : '' }}

                                                                    />
                                                                </div>
                                                                <div class="col-md-3 cssChange">
                                                                    <span className="cssDocumentClaimScreen1">-</span>
                                                                </div>
                                                                <div class="col-md-3 cssChange cssDocumentClaimScreen2">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup></label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        maxlength="15"
                                                                        name='pharmacyAdjAmtInputField2'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.pharmacyAdjAmtInputField2 = el)}
                                                                        style={{ borderColor: formErrors.pharmacyAdjAmtInputField2 ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                    />
                                                                </div>
                                                                <div class="col-md-3 cssChange">
                                                                    <span className="cssDocumentClaimScreen3">=</span>
                                                                </div>
                                                                <div class="col-md-3 cssChange cssDocumentClaimScreen4" >
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control cssDocumentClaimScreen5':'form-control cssDocumentClaimScreen5 cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        readOnly
                                                                        name='pharmacyAdjAmtInputFieldResult'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.pharmacyAdjAmtInputFieldResult = el)}
                                                                    />
                                                                </div>
                                                            </div>
                                                      
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-3  cssChange">
                                                                    <label for="validationDefault01">Client Adj Amt</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        maxlength="15"
                                                                        name='ClientAdjAmtInputField1'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.ClientAdjAmtInputField1 = el)}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                   />
                                                                </div>
                                                                <div class="col-md-3  cssChange">
                                                                    <span className="cssDocumentClaimScreen1">-</span>
                                                                </div>
                                                                <div class="col-md-3  cssChange cssDocumentClaimScreen2">
                                                                    <label for="validationDefault01"></label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        maxlength="15"
                                                                        name='ClientAdjAmtInputField2'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.ClientAdjAmtInputField2 = el)}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                  />
                                                                </div>
                                                                <div class="col-md-3  cssChange">
                                                                    <span className="cssDocumentClaimScreen3">=</span>
                                                                </div>
                                                                <div class="col-md-3  cssChange cssDocumentClaimScreen4">
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control cssDocumentClaimScreen5':'form-control cssDocumentClaimScreen5 cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        readOnly
                                                                        name='ClientAdjAmtResult'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.ClientAdjAmtResult = el)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-4  cssChange">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>Contact Name</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault01"
                                                                        placeholder=""
                                                                        required
                                                                        maxlength="50"
                                                                        name='contactName'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.contactName = el)}
                                                                        style={{ borderColor: formErrors.contactName ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                    />
                                                                </div>
                                                                <div class="col-md-4  cssChange cssChange1">
                                                                    <label for="validationDefault02"><sup className="colorRedFontBold" >*</sup># of Calls</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault02"
                                                                        maxlength="3"
                                                                        placeholder=""
                                                                        required
                                                                        name='calls'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.calls = el)}
                                                                        style={{ borderColor: formErrors.calls ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                    />
                                                                </div>
                                                                <div class="col-md-3  cssChange cssChange1">
                                                                    <label for="validationDefaultUsername"><sup className="colorRedFontBold" >*</sup># of Emails</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault02"
                                                                        maxlength="3"
                                                                        placeholder=""
                                                                        required
                                                                        name='emails'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.emails = el)}
                                                                        style={{ borderColor: formErrors.emails ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-4  cssChange ">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>RT or Report</label>
                                                                    <select class="custom-select form-control"
                                                                        name="rts_report"
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        onChange={handleChangeDcs}
                                                                        ref={(el) => (inputDcsRef.current.rts_report = el)}
                                                                        style={{ borderColor: formErrors.rts_report ? 'red' : '' }}
                                                                        disabled={maxVersion.value!==versionSelected.value?true:false}

                                                                    >
                                                                        <option value="Select RT or Report">Select RT or Report</option>
                                                                        <option value="RTS-REAL TIME">RTS-REAL TIME</option>
                                                                        <option value="REPORT">REPORT</option>
                                                                    </select>
                                                                </div>
                                                                <div class="col-md-4  cssChange cssChange1">
                                                                    <label for="validationDefault02"><sup className="colorRedFontBold" >*</sup>Violation</label>
                                                                    <select class="custom-select form-control" name="violation"
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        ref={(el) => (inputDcsRef.current.violation = el)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        style={{ borderColor: formErrors.violation ? 'red' : '' }}
                                                                        disabled={maxVersion.value!==versionSelected.value?true:false}

                                                                    >
                                                                        <option value="Select Violation">Select Violation</option>
                                                                        {options.map((option, index) => (
                                                                            <option key={index}
                                                                                value={option}
                                                                                style={{ color: 'black', fontSize: option === "******************************************************" ? '20px' : '16px' }}
                                                                                disabled={option === "******************************************************" ? true : false}
                                                                            >{option}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div class="col-md-3  cssChange cssChange1">
                                                                    <label for="validationDefault02">Claim Reference #</label>
                                                                    <input
                                                                        type="text"
                                                                        class={maxVersion.value===versionSelected.value?'form-control':'form-control cssDocClaim1'}
                                                                        id="validationDefault02"
                                                                        placeholder=""
                                                                        maxlength="15"
                                                                        required
                                                                        name='claimReference'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        ref={(el) => (inputDcsRef.current.claimReference = el)}
                                                                        style={{ borderColor: formErrors.claimReference ? 'red' : '' }}
                                                                        readOnly={maxVersion.value!==versionSelected.value?true:false}

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-4  cssChange cssDocumentClaimScreen6 " className="cssDocumentClaimScreen6">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>Sig</label>
                                                                    <TextField
                                                                        type="text"
                                                                        id="outlined-multiline-flexible"
                                                                        label=""
                                                                        multiline
                                                                        inputProps={{
                                                                            maxLength: 150,
                                                                            readOnly:maxVersion.value!==versionSelected.value?true:false,
                                                                            className:maxVersion.value===versionSelected.value?'':"cssDocClaim1",
                                                                        }}
                                                                        placeholder=""
                                                                        required
                                                                        name='Sig'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        inputRef={(el) => (inputDcsRef.current.Sig = el)}
                                                                        error={!!formErrors.Sig}
                                                                        style={{ width: '100%' }}

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-4  cssChange cssDocumentClaimScreen6" className="cssDocumentClaimScreen6">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>R/R</label>
                                                                    <TextField
                                                                        type="text"
                                                                        id="outlined-multiline-flexible"
                                                                        label=""
                                                                        multiline
                                                                        inputProps={{
                                                                            maxLength: 150,
                                                                            readOnly:maxVersion.value!==versionSelected.value?true:false,
                                                                            className:maxVersion.value===versionSelected.value?'':"cssDocClaim1",
                                                                        }}
                                                                        placeholder=""
                                                                        required
                                                                        name='rOrr'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        inputRef={(el) => (inputDcsRef.current.rOrr = el)}
                                                                        error={!!formErrors.rOrr}
                                                                        style={{ width: '100%' }}

                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="form-row cssChange4">
                                                                <div class="col-md-4  cssChange " className="cssDocumentClaimScreen6">
                                                                    <label for="validationDefault01"><sup className="colorRedFontBold" >*</sup>Notes</label>
                                                                    <TextField
                                                                        type="text"
                                                                        id="outlined-multiline-flexible"
                                                                        label=""
                                                                        multiline
                                                                        placeholder=""
                                                                        required
                                                                        name='notes'
                                                                        onChange={(event) => handleChangeDcs(event)}
                                                                        onBlur={(event) => handleChangeDcs(event, "onBlur")}
                                                                        inputRef={(el) => (inputDcsRef.current.notes = el)}
                                                                        inputProps={{
                                                                            readOnly:maxVersion.value!==versionSelected.value?true:false,
                                                                            className:maxVersion.value===versionSelected.value?'':"cssDocClaim1",

                                                                          }}
                                                                        //value={inputsDcs.notes}
                                                                        error={!!formErrors.notes}
                                                                        style={{ width: '100%', border: "2px" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <br></br>
                                                        </form>
                                                    </div>
                                                </div>
                                                <div class="screenShotBottom">
                                                    <div >
                                                        {valBottom.map((data, i) => {

                                                            return (
                                                                <div >
                                                                    <div class="item" id={`item-${i}`} >
                                                                        {maxVersion.value===versionSelected.value?<button type="button" class="btn-close" aria-label="Close" id={`btn-${i}`} onClick={() => handleDeleteBottom(i)}></button>:''}
                                                                        <CopyPaste id={i} url={data[0]} updateValueAtIndex={updateBottomValueAtIndex} maxVersion={maxVersion} versionSelected={versionSelected} draggable={true} dragScrnshot={()=>dragScrnshot(i,'bottom')} dropScrnshot={dropScrnshotBottom} handleDragOverScrnshot={handleDragOverScrnshot} handleAdd={()=>handleAddBetweenBottom(i)} alertRef={alertRef}/>
                                                                    </div>

                                                                </div>
                                                            )
                                                        }
                                                        )}
                                                    </div>
                                                    {maxVersion.value===versionSelected.value?<button onClick={() => handleAddBottom()} type="button" class="btn btn-primary darkBlue">Add Screenshot</button>:''}
                                                </div>
                                            </div>


                                            {((showSubmitButtons) && (maxVersion === versionSelected || versionOptions.length === 0||maxVersion.value===versionSelected.value)) &&
                                                <div class="documentClaimSubmitButtonsRow">
                                                    {(creator === msid) &&(claimStatus!=='Request For Approval')&&
                                                        <div>
                                                            <div className="row mb-3 mt-2">
                                                                <div className="col-3 ">
                                                                </div>
                                                                <div className="col-3 ">
                                                                    <button onClick={getImage} type="button" class="btn btn-primary finalDecisionAndSaveButton">
                                                                        <div class="checkbox-wrapper-13">
                                                                            <input id="c1-13" type="checkbox" checked={isFinalDecisionChecked} onChange={handleFinalDecisionCheckBoxChange} />
                                                                            <label for="c1-13">Final Decision Made</label>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                                <div className="col-3 ">
                                                                    <button onClick={() => submitDocumentClaimData("saveOrSubmit", "")} type="button" class="btn btn-primary finalDecisionAndSaveButton width70"disabled={buttonClicked.current}>
                                                                        {(isFinalDecisionChecked) ? (
                                                                            <label className="cursorPointer" >Submit</label>
                                                                        ) : (<label className="cursorPointer">Save & Continue</label>)
                                                                        }
                                                                    </button>
                                                                </div>
                                                                <div className="col-3 ">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {(creator !== msid) &&
                                                        <div >
                                                            <div className="row mb-3 mt-2">
                                                                <div className="col-12 colorRed">
                                                                    You need to assign this case to yourself for making changes.
                                                            </div>
                                                            </div>

                                                        </div>}
                                                       
                                                </div>
                                            }
                                             {(creator === msid) &&(claimStatus==='Request For Approval')&&
                                                        <div class="documentClaimSubmitButtonsRow">
                                                           <div className="row mb-3 mt-2">
                                                                <div className="col-12 colorRed">
                                                                    Since claim is in Request For Approval status, you are not allowed to make any changes.
                                                            </div>
                                                            </div>
                                                        </div>
                                                    }
                                            {(showAccordion||(claimStatus==="In-Progress" && (userRole===2||userRole===4))||(claimStatus==='Request For Approval'&&(userRole===1||userRole===3))) &&
                                                <div className="accordion">
                                                    <Accordion>
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                            sx={{ backgroundColor: '#002677', fontWeight: 'bold', color: 'white' }}
                                                        >
                                                            Comments
                                                    </AccordionSummary>
                                                        <AccordionDetails>
                                                            <div className="viewHistory" onClick={handleViewHistoryPopup}>View History</div>
                                                            {data === '' || data === null ?
                                                                (<div className="previousComments" >
                                                                    <div><label className="commentName"></label></div>
                                                                </div>)
                                                                :
                                                                (<div className="previousComments" >
                                                                      {  
                                                                        data.map((item,index)=>{
                                                                            return(
                                                                                <div>
                                                                            <div><label className="commentName">{item.creator}</label> (<label>{item.status}</label>) : <label>{item.comment}</label></div>
                                                                            <div> <label>{item.time}</label></div>
                                                                            <img src={item.image} style={{ maxWidth: '100%' }} />
                                                                            </div>
                                                                            )
                                                                        })
                                                                    }
                                                                    
                                                                </div>)}
                                                            <Box
                                                                component="form"
                                                                sx={{
                                                                    '& .MuiTextField-root': { m: 1 },
                                                                }}
                                                                noValidate
                                                                autoComplete="off"
                                                            >
                                                                <div className="marginLeftminusOne">
                                                                    <TextField
                                                                        id="outlined-multiline-flexible"
                                                                        label="Click here to add comment"
                                                                        InputLabelProps={{
                                                                            style: {
                                                                                marginTop: '0%',
                                                                            }
                                                                        }}
                                                                        multiline
                                                                        maxRows={20}
                                                                        onChange={(event) => handleChangeComments(event)}
                                                                        inputRef={(el) => (commentRef.current.commentData = el)}
                                                                        style={{ width: '98.5%' }}
                                                                        error={!!commentError}

                                                                    />
                                                                </div>
                                                            </Box>
                                                            {(claimStatus==='In-Progress'||claimStatus==='Request For Approval')?'':
                                                            <div >
                                                                {commentScrnshot.map((data, i) => {
                                                                    return (
                                                                        <div>
                                                                            <div class="item" id={`item-${i}`}>
                                                                                <CopyPaste calledFrom="docClaim" id={i} url={data[0]} updateValueAtIndex={valueOfCommentScreenShot} alertRef={alertRef} />
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            }
                                                            {
                                                                (userRole === 2||userRole===4) &&
                                                                <div className="row mb-3 mt-5">
                                                                    {(claimStatus === "Pending Review") &&
                                                                        <>
                                                                            <div className="col-12 colorRed ">
                                                                                Since claim is in Pending Review with manager, you are not allowed to make any changes.
                                                                    </div>
                                                                        </>
                                                                    }
                                                                    {(claimStatus !== "Pending Review"&&claimStatus !== "In-Progress" && claimStatus!=='Request For Approval') &&
                                                                        <>
                                                                            {(maxVersion === versionSelected||maxVersion.value===versionSelected.value) ?
                                                                                <>
                                                                                    <div className="col-3 ">
                                                                                    </div>
                                                                                    <div className="col-3 ">
                                                                                    </div>
                                                                                    <div className="col-3 completeCheckbox">
                                                                                        <div onClick={getImage} type="button" class="btn btn-primary finalDecisionAndSaveButton">
                                                                                            <div class="checkbox-wrapper-13">
                                                                                                <input id="c1-13" type="checkbox" checked={isUpdateClaimChecked} onClick={() => handleIsUpdateClaimChecked("clicked")} />
                                                                                                <label for="c1-13">Submit to RxWeb/RxClaim</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-3 ">
                                                                                        <button onClick={() => submitDocumentClaimData("updateClaim", "")} type="button" class="btn btn-primary finalDecisionAndSaveButton width70 marginTop4" disabled={buttonClicked.current}>
                                                                                            <div class="checkbox-wrapper-13">
                                                                                                <label className="cursorPointer" >Update Claim</label>
                                                                                            </div>
                                                                                        </button>
                                                                                    </div>
                                                                                </>
                                                                                :
                                                                                <div className="col-12 colorRed  ">
                                                                                    Select Latest Version For taking actions.
                                                                        </div>
                                                                            }
                                                                        </>

                                                                    }
                                                                </div>
                                                            }
                                                            {
                                                                ((userRole === 1||userRole===3) && creator === msid && claimStatus!=='In-Progress'&&claimStatus!=='Request For Approval') &&
                                                                <div className="row mb-3 mt-5">
                                                                    <div className="col-3 ">
                                                                    </div>
                                                                    <div className="col-3 ">
                                                                    </div>
                                                                    {(maxVersion === versionSelected||maxVersion.value===versionSelected.value) ?
                                                                        <>
                                                                            <div className="col-3 completeCheckbox">
                                                                                <div onClick={getImage} type="button" class="btn btn-primary finalDecisionAndSaveButton" >
                                                                                    <div class="checkbox-wrapper-13">
                                                                                        <input id="c1-13" type="checkbox" checked={isUpdateClaimChecked} onClick={() => handleIsUpdateClaimChecked("clicked")} />
                                                                                        <label for="c1-13">Submit to RxWeb/RxClaim</label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-3 ">
                                                                                <button onClick={() => submitDocumentClaimData("updateClaim", "")} type="button" class="btn btn-primary finalDecisionAndSaveButton width70 marginTop4" disabled={buttonClicked.current}>
                                                                                    <div class="checkbox-wrapper-13">
                                                                                        <label className="cursorPointer" >Update Claim</label>
                                                                                    </div>
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        <div className="col-6 colorRed marginLeftMinus50 ">
                                                                            Select Latest Version For taking actions.
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }
                                                            {
  (claimStatus==='In-Progress') &&
  <div className="row mb-3 mt-5">
      <div className="col-3 ">
      </div>
      <div className="col-3 ">
      </div>
      {(maxVersion === versionSelected||maxVersion.value === versionSelected.value) ?
          <>
          {show===true?
               <div className="col-3 ">
                {role==='auditor'?
             <button onClick={() => handleRequestForApproval("Request For Approval")} type="button" class="btn btn-primary finalDecisionAndSaveButton width58 marginLeft88"disabled={buttonClicked.current}>
             Request for Approval
         </button>:''    
            }
                
                </div>
                :''}
          </>
          :''
      }
  </div>
    }
    {
        ((userRole === 1||userRole===3) && creator !== msid &&claimStatus==='Request For Approval') &&
        <div className="row mb-3 mt-5">
            {(maxVersion === versionSelected||maxVersion.value === versionSelected.value) ?
                <>
                    <div className="col-4 ">
                    </div>
                    <div className="col-4 ">
                    </div>
                    {(claimStatus === "Request For Approval") &&
                        <>
                        {(show===true)?
                        <>
                            <div className="col-2 ">
                                <button onClick={() => handleRequestForApproval("Request Approved")} type="button" class="btn btn-primary finalDecisionAndSaveButton width55"disabled={buttonClicked.current}>
                                    Approve
                 </button>
                            </div>
                            <div className="col-2 ">
                                <button onClick={() => handleRequestForApproval("Request Denied")} type="button" class="btn btn-primary finalDecisionAndSaveButton width55"disabled={buttonClicked.current}>
                                    Deny
                </button>
                            </div>
                            </>
                            :''}
                        </>
                    }
                    </>:''
                    }
        </div>            

    }
                                                            {/*admin starts*/}
                                                            {((userRole === 1||userRole===3) && creator !== msid) &&
                                                                <div className="row mb-3 mt-5">
                                                                    {(maxVersion === versionSelected||maxVersion.value===versionSelected.value) ?
                                                                        <>
                                                                            <div className="col-4 ">
                                                                            </div>
                                                                            <div className="col-4 ">
                                                                            </div>
                                                                            {(claimStatus === "Pending Review") &&
                                                                                <>
                                                                                    <div className="col-2 ">
                                                                                        <button onClick={() => submitDocumentClaimData("Approve", "approved")} type="button" class="btn btn-primary finalDecisionAndSaveButton width55"disabled={buttonClicked.current}>
                                                                                            Approve
                                                                         </button>
                                                                                    </div>
                                                                                    <div className="col-2 ">
                                                                                        <button onClick={() => submitDocumentClaimData("Reject", "denied")} type="button" class="btn btn-primary finalDecisionAndSaveButton width55"disabled={buttonClicked.current}>
                                                                                            Deny
                                                                        </button>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                            {((claimStatus === "Completed" || claimStatus === "QA Done" || claimStatus === "Approved" || claimStatus === "Fallout") && creator !== msid) &&
                                                                                <>
                                                                                    <div className="col-2 ">
                                                                                        <button onClick={() => submitDocumentClaimData("Send Back", "sent back")} type="button" class="btn btn-primary finalDecisionAndSaveButton width55"disabled={buttonClicked.current}>
                                                                                            Send Back
                                                                             </button>
                                                                                    </div>
                                                                                    <div className="col-2 ">
                                                                                        <button onClick={() => submitDocumentClaimData("QA Done", "QA done")} type="button" class="btn btn-primary finalDecisionAndSaveButton width55"disabled={buttonClicked.current}>
                                                                                            QA Done
                                                                            </button>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </>
                                                                        : ((claimStatus !== "Denied" && claimStatus !== "Sent Back") ?
                                                                            <div className="col-12 colorRed  ">
                                                                                Select Latest Version For taking actions.
                                                                        </div> : "")
                                                                    }
                                                                    {(claimStatus === "Sent Back") &&
                                                                        <>
                                                                            <div className="col-12 colorRed ">
                                                                                Since claim is Sent Back, you are not allowed to make any changes.
                                                                        </div>
                                                                        </>
                                                                    }

                                                                    {(claimStatus === "Denied") &&
                                                                        <>
                                                                            <div className="col-12 colorRed ">
                                                                                Since claim is Rejected, you are not allowed to make any changes.
                                                                        </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                            }
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </div>
                                               } 
                                        </div>
                                    </div>
                                </section>
                            </div>
                        }
                        <SnackBar  ref={alertRef} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default DocumentClaimScreen
